// Generated by Avo VERSION 165.1.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;
  
  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "D7U8qXZqpeuBzuZTJr4l";
  var __INSPECTOR__ = null;
  
  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);
  
  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }
  
  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };
  
    const WebDebuggerAssertions = {
      hasKey(obj, key) {
        return obj && obj[key] != null;
      },
      assertKey(obj, key, assert) {
        if (this.hasKey(obj, key) && assert(obj[key])) {
          return true;
        } else {
          throw new Error('WebDebugger: Object key: "' + key + '" failed assertion.')
        }
      },
      assertKeys(obj, arrayOfAssertions) {
        return arrayOfAssertions.every(assertionForKey => {
          if (this.hasKey(assertionForKey, "key") && this.hasKey(assertionForKey, "assert")) {
            return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
          } else {
            throw new Error('WebDebugger: Object form for assertion invalid.');
          }
        });
      },
      assertInt(int) {
        return Number.isInteger(int);
      },
    };

    var WebDebuggerPosition = {
      position: {
        BOTTOM_RIGHT: 'BottomRight',
        BOTTOM_LEFT: 'BottomLeft',
        TOP_RIGHT: 'TopRight',
        TOP_LEFT: 'TopLeft',
      },
      BottomRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        };
      },
      BottomLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        };
      },
      TopRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        };
      },
      TopLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        };
      },
    }
    
  
  InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties, groupProperties) {
      const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties) + "Group Props:" + JSON.stringify(groupProperties);

      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties, "Group Props:", groupProperties);
    },

    log: function log(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
        return
      }
      typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
  };
  
  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "3zCmF5E1OHnhZRN2xJPO",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "YlokXVpIQVXO68TO4Rm5",
    "se": (new Date()).toISOString(),
    "so": "xFLbWhqhHE",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "3zCmF5E1OHnhZRN2xJPO",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "YlokXVpIQVXO68TO4Rm5",
    "se": (new Date()).toISOString(),
    "so": "xFLbWhqhHE",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}
  
  
  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "YlokXVpIQVXO68TO4Rm5",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}
  
  
  var Platform = {
    WEB: "web",
    I_O_S: "iOS",
    ANDROID: "android",
    MFEP: "MFEP",
  };
  
  var PaymentType = {
    IDEAL: "Ideal",
    CREDIT_CARD: "Credit Card",
  };
  
  var Schema = {
    IGLU_NL_NS_LOGIN_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_start/jsonschema/1-0-0",
    IGLU_NL_NS_LOGIN_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_error/jsonschema/1-0-0",
    IGLU_NL_NS_VIEW_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/view/jsonschema/1-0-0",
    IGLU_NL_NS_CART_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/cart_remove/jsonschema/1-0-0",
    IGLU_NL_NS_CHAT_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/chat_start/jsonschema/1-0-0",
    IGLU_NL_NS_CHECKOUT_PROGRESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/checkout_progress/jsonschema/1-0-0",
    IGLU_NL_NS_CHECKOUT_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/checkout_start/jsonschema/1-0-0",
    IGLU_NL_NS_CONTENT_SHARE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/content_share/jsonschema/1-0-0",
    IGLU_NL_NS_COOKIE_CHANGE_PERMISSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0",
    IGLU_NL_NS_EXPERIMENT_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
    IGLU_NL_NS_FILE_DOWNLOAD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/file_download/jsonschema/1-0-0",
    IGLU_NL_NS_FORM_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/form_error/jsonschema/1-0-0",
    IGLU_NL_NS_FORM_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/form_start/jsonschema/1-0-0",
    IGLU_NL_NS_ITEM_SELECT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/item_select/jsonschema/1-0-0",
    IGLU_NL_NS_ITEM_VIEW_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/item_view/jsonschema/1-0-0",
    IGLU_NL_NS_KEUZEHULP_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
    IGLU_NL_NS_LEAD_GENERATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
    IGLU_NL_NS_NBA_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/nba_success/jsonschema/1-0-0",
    IGLU_NL_NS_PAGE_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/page_error/jsonschema/1-0-0",
    IGLU_NL_NS_PUSH_CONSENT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/push_consent/jsonschema/1-0-0",
    IGLU_NL_NS_REGISTRATION_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/registration_start/jsonschema/1-0-0",
    IGLU_NL_NS_REGISTRATION_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/registration_success/jsonschema/1-0-0",
    IGLU_NL_NS_REISPLANNER_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0",
    IGLU_NL_NS_REISPLANNER_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
    IGLU_NL_NS_REISREGISSEUR_CHANGE_PERMISSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
    IGLU_NL_NS_REISVERGELIJKER_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
    IGLU_NL_NS_REISVERGELIJKER_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
    IGLU_NL_NS_SCROLL_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/scroll/jsonschema/1-0-0",
    IGLU_NL_NS_SEARCH_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/search_start/jsonschema/1-0-0",
    IGLU_NL_NS_VIDEO_COMPLETE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/video_complete/jsonschema/1-0-0",
    IGLU_NL_NS_VIDEO_PROGRESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/video_progress/jsonschema/1-0-0",
    IGLU_NL_NS_VIDEO_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/video_start/jsonschema/1-0-0",
    IGLU_NL_NS_VISIT_QUALIFIED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
    IGLU_NL_NS_APP_CLEAR_DATA_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_clear_data/jsonschema/1-0-0",
    IGLU_NL_NS_PURCHASE_INTENTION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/purchase_intention/jsonschema/1-0-0",
    IGLU_NL_NS_SESSION_COUNT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/session_count/jsonschema/1-0-0",
    IGLU_NL_NS_SESSION_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/session_start/jsonschema/1-0-0",
    IGLU_NL_NS_FORM_SUBMIT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/form_submit/jsonschema/1-0-0",
    IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0",
    IGLU_NL_NS_WIDGET_ADD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/widget_add/jsonschema/1-0-0",
    IGLU_NL_NS_WIDGET_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/widget_remove/jsonschema/1-0-0",
    IGLU_NL_NS_STATION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/station/jsonschema/1-0-0",
    IGLU_NL_NS_DETAIL_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/detail_click/jsonschema/1-0-0",
    IGLU_NL_NS_VOORZIENINGEN_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0",
    IGLU_NL_NS_KAART_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/kaart_click/jsonschema/1-0-0",
    IGLU_NL_NS_MODALITIES_FILTER_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/modalities_filter/jsonschema/1-0-0",
    IGLU_NL_NS_PLAN_VANAF_HIER_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0",
    IGLU_NL_NS_TRAJECT_ADD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/traject_add/jsonschema/1-0-0",
    IGLU_NL_NS_TRAJECT_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/traject_remove/jsonschema/1-0-0",
    IGLU_NL_NS_TRAJECT_SEINTJES_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/traject_seintjes/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_RECEIVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_receive/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_OPEN_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_open/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_FOREGROUND_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_foreground/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_DISMISS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_dismiss/jsonschema/1-0-0",
    IGLU_NL_NS_APP_EXCEPTION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_exception/jsonschema/1-0-0",
    IGLU_NL_NS_APP_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_remove/jsonschema/1-0-0",
    IGLU_NL_NS_APP_UPDATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_update/jsonschema/1-0-0",
    IGLU_NL_NS_OS_UPDATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/os_update/jsonschema/1-0-0",
    IGLU_NL_NS_SERVER_PURCHASE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/server_purchase/jsonschema/1-0-0",
    IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0",
    IGLU_NL_NS_LOGIN_SUCCESS_JSONSCHEMA_2MINUS0MINUS3: "iglu:nl.ns/login_success/jsonschema/2-0-3",
    IGLU_NL_NS_PAGE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/page/jsonschema/1-0-0",
    IGLU_NL_NS_COOKIE_CONSENT_SUBMIT_JSONSCHEMA_2MINUS0MINUS2: "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
    IGLU_NL_NS_COOKIE_CONSENT_VIEW_JSONSCHEMA_2MINUS0MINUS2: "iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2",
    IGLU_NL_NS_LOGIN_STATUS_UPDATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_status_update/jsonschema/1-0-0",
    IGLU_NL_NS_CLASS_CHANGE_CONFIRM_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/class_change_confirm/jsonschema/1-0-0",
    IGLU_NL_NS_CLASS_CHANGE_SET_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/class_change_set/jsonschema/1-0-0",
    IGLU_NL_NS_NBA_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/nba_context/jsonschema/1-0-0",
    IGLU_NL_NS_SCREEN_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/screen_context/jsonschema/1-0-0",
    IGLU_NL_NS_FEEDBACK_GIVE_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
    IGLU_NL_NS_GLOBAL_CONTEXTS_ADD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/global_contexts_add/jsonschema/1-0-0",
    IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/page_context/jsonschema/1-0-1",
    IGLU_NL_NS_CONSENT_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/consent_context/jsonschema/1-0-0",
    IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0",
    IGLU_NL_NS_GLOBAL_CONTEXTS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/global_contexts/jsonschema/1-0-0",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS0MINUS7: "iglu:nl.ns/screen_view/jsonschema/1-0-7",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/add_to_cart/jsonschema/1-0-5",
    IGLU_NL_NS_TRAVEL_PLANNER_PLAN_JOURNEY_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0",
    IGLU_NL_NS_AUTHENTICATION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/authentication/jsonschema/1-0-0",
    IGLU_NL_NS_BANNER_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/banner_click/jsonschema/1-0-3",
    IGLU_NL_NS_CART_ADD_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/cart_add/jsonschema/1-0-3",
    IGLU_NL_NS_CHECKBOX_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/checkbox_click/jsonschema/1-0-3",
    IGLU_NL_NS_CHIP_FILTER_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/chip_filter_click/jsonschema/1-0-3",
    IGLU_NL_NS_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/click/jsonschema/1-0-2",
    IGLU_NL_NS_CLICKED_OPTION_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/clicked_option/jsonschema/1-0-1",
    IGLU_NL_NS_COOKIE_CONSENT_CHANGE_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2",
    IGLU_NL_NS_DATEPICKER_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/datepicker_click/jsonschema/1-0-3",
    IGLU_NL_NS_ELEMENT_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/element_click/jsonschema/1-0-2",
    IGLU_NL_NS_ELEMENT_VIEW_JSONSCHEMA_4MINUS0MINUS2: "iglu:nl.ns/element_view/jsonschema/4-0-2",
    IGLU_NL_NS_ERROR_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/error/jsonschema/1-0-1",
    IGLU_NL_NS_EXPANDABLE_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/expandable_click/jsonschema/1-0-3",
    IGLU_NL_NS_EXPERIMENT_VIEW_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
    IGLU_NL_NS_LINK_CLICK_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/link_click/jsonschema/1-0-1",
    IGLU_NL_NS_LOGOUT_SUCCESS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/logout_success/jsonschema/1-0-1",
    IGLU_NL_NS_NBA_AUDIENCE_ADD_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
    IGLU_NL_NS_NBA_VIEW_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/nba_view/jsonschema/1-0-3",
    IGLU_NL_NS_PAGE_VIEW_JSONSCHEMA_4MINUS0MINUS3: "iglu:nl.ns/page_view/jsonschema/4-0-3",
    IGLU_NL_NS_REISPLANNER_PLAN_TRIP_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3",
    IGLU_NL_NS_SEARCH_VIEW_RESULTS_JSONSCHEMA_2MINUS0MINUS3: "iglu:nl.ns/search_view_results/jsonschema/2-0-3",
    IGLU_NL_NS_SELECT_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/select_click/jsonschema/1-0-2",
    IGLU_NL_NS_SELECTABLE_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/selectable_click/jsonschema/1-0-3",
    IGLU_NL_NS_SERVER_EXPERIMENTS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/server_experiments/jsonschema/1-0-1",
    IGLU_NL_NS_SUBSCRIPTION_CANCEL_SELECT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1",
    IGLU_NL_NS_SUBSCRIPTION_CHANGE_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/subscription_change/jsonschema/1-0-1",
    IGLU_NL_NS_SUBSCRIPTION_CHANGE_SELECT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/subscription_change_select/jsonschema/1-0-2",
    IGLU_NL_NS_TOGGLE_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/toggle_click/jsonschema/1-0-3",
    IGLU_NL_NS_TOOLTIP_CLICK_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/tooltip_click/jsonschema/1-0-4",
    IGLU_NL_NS_BUTTON_CLICK_JSONSCHEMA_2MINUS0MINUS6: "iglu:nl.ns/button_click/jsonschema/2-0-6",
    IGLU_NL_NS_APP_OS_UNSUPPORTED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0",
    IGLU_NL_NS_UNSUPPORTED_APP_VERSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0",
    IGLU_NL_NS_UNSUPPORTED_OS_VERSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0",
    IGLU_NL_NS_DEPRECATED_APP_VERSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0",
    IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/add_payment_info/jsonschema/1-0-2",
    IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1MINUS0MINUS6: "iglu:nl.ns/add_to_cart/jsonschema/1-0-6",
    IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/begin_checkout/jsonschema/1-0-2",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS7: "iglu:nl.ns/purchase/jsonschema/2-0-7",
    IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4",
    IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/view_item/jsonschema/1-0-2",
    IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/view_item_list/jsonschema/1-0-2",
    IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1",
    IGLU_NL_NS_JOURNEY_DETAIL_SAVE_TRIP_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0",
    IGLU_NL_NS_JOURNEY_DETAIL_SET_NOTIFICATIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_DELETE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_EXTRA_OPTIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_MODAL_CANCEL_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_MODAL_EXTRA_OPTIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_MODAL_SAVE_NOTIFICATIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_SAVE_CHANGES_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0",
    IGLU_NL_NS_BOTTOM_BAR_SAVED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0",
    IGLU_NL_NS_HOMEPAGE_SAVED_TRIPS_WIDGET_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0",
    IGLU_NL_NS_HOMEPAGE_SAVED_TRIPS_WIDGET_TO_SAVED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0",
  };
  
  var ChatInitiator = {
    CLICK: "click",
    HOVER: "hover",
    PREVIOUS_CHAT_SESSION: "previous_chat_session",
    TIME_DELAY: "time_delay",
  };
  
  var Language = {
    NL: "nl",
    EN: "en",
  };
  
  var NsShop = {
    NS_BUSINESSCARD: "ns_businesscard",
    SPOORDEELWINKEL: "spoordeelwinkel",
    ABONNEMENTEN: "abonnementen",
    LOSSE_VERVOERSBEWIJZEN: "losse_vervoersbewijzen",
    LVB_KAARTJES: "lvb_kaartjes",
    LVB_APP: "lvb_app",
    NS_MINUSFLEX: "ns-flex",
  };
  
  var FeedbackPlatform = {
    USABILLA: "usabilla",
    GETFEEDBACK: "getfeedback",
    QUALTRICS: "qualtrics",
  };
  
  var Currency = {
    EUR: "EUR",
  };
  
  var OriginType = {
    STATION: "station",
    ADDRESS: "address",
    STOP: "stop",
    POI: "poi",
    UNKNOWN: "unknown",
  };
  
  var ItemListName = {
    KAARTJES: "Kaartjes",
    NSBC: "NSBC",
  };
  
  var CustomerEntity = {
    KAARTHOUDER: "kaarthouder",
    CONTACTPERSOON: "contactpersoon",
  };
  
  var Cluster = {
    ABO: "abo",
    LVB: "lvb",
    NSI: "nsi",
    OVK: "ovk",
    RCR: "rcr",
  };
  
  var ChatClickSource = {
    BUTTON: "button",
    CANCELLATION_LINK: "cancellation_link",
    CHAT_LINK: "chat_link",
    LIVE_CHAT: "live_chat",
  };
  
  var WebsiteVersion = {
    CONSUMENT: "consument",
    ZAKELIJK: "zakelijk",
  };
  
  var MijnnsVersion = {
    MIJNNS: "mijnns",
    MIJNNS_ZAKELIJK: "mijnns_zakelijk",
  };
  
  var DestinationType = {
    STATION: "station",
    ADDRESS: "address",
    STOP: "stop",
    POI: "poi",
    UNKNOWN: "unknown",
  };
  
  var ItemListId = {
    PLP_KAARTJES: "plp_kaartjes",
    NSBC_BCA: "nsbc_bca",
  };
  
  var NsEnvironment = {
    ACC: "acc",
    TEST: "test",
    PROD: "prod",
    TEST2: "test2",
    TEST3: "test3",
    TESTAUT: "testaut",
    TESTAUT2: "testaut2",
    TESTAUT3: "testaut3",
    DEV_MINUSLOCALHOST: "dev-localhost",
    UNITTEST: "unittest",
  };
  
  var Method = {
    FACEBOOK: "facebook",
    TWITTER: "twitter",
    INSTAGRAM: "instagram",
    YOUTUBE: "youtube",
    LINKEDIN: "linkedin",
  };
  
  function assertOptionalCookieConsentStatus(cookieConsentStatus, label_) {
    var messages = [];
    if (cookieConsentStatus !== undefined && cookieConsentStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("-DxiaheG2mil", label_ ? "cookie_consent_status" + ": " + label_ : "cookie_consent_status", cookieConsentStatus));
    }
    return messages;
  }
  
  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("-PddLxwT_", label_ ? "platform" + ": " + label_ : "platform", platform));
    if ("web" !== platform &&
        "iOS" !== platform &&
        "android" !== platform &&
        "MFEP" !== platform) {
      var message = (label_ ? "platform" + ": " + label_ : "platform") + " should match one of the following values [ web | iOS | android | MFEP ] but you provided the value " + platform
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "-PddLxwT_", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalPaymentType(paymentType, label_) {
    var messages = [];
    if (paymentType !== undefined && paymentType !== null) {
      messages = messages.concat(AvoAssert.assertList("06ak1UmwgYlK", "payment_type", paymentType));
      paymentType.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("06ak1UmwgYlK", "item at index " + index + " in payment_type", value));
        if ("Ideal" !== value &&
            "Credit Card" !== value) {
          var message = (label_ ? "item at index " + index + " in payment_type" + ": " + label_ : "item at index " + index + " in payment_type") + " should match one of the following values [ Ideal | Credit Card ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "06ak1UmwgYlK", message: message}]);
        }
      });
    }
    return messages;
  }
  
  function assertIntercityDirect(intercityDirect, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("17s21jQ4G", label_ ? "intercity_direct" + ": " + label_ : "intercity_direct", intercityDirect));
    return messages;
  }
  
  function assertOptionalIntercityDirect(intercityDirect, label_) {
    var messages = [];
    if (intercityDirect !== undefined && intercityDirect !== null) {
      messages = messages.concat(AvoAssert.assertBool("17s21jQ4G", label_ ? "intercity_direct" + ": " + label_ : "intercity_direct", intercityDirect));
    }
    return messages;
  }
  
  function assertValue(value, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("1WkP-6sA8x_5", label_ ? "value" + ": " + label_ : "value", value));
    return messages;
  }
  
  function assertVisible(visible, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("2b5JV7Hc-MhF", label_ ? "visible" + ": " + label_ : "visible", visible));
    return messages;
  }
  
  function assertOptionalUtmCampaign(utmCampaign, label_) {
    var messages = [];
    if (utmCampaign !== undefined && utmCampaign !== null) {
      messages = messages.concat(AvoAssert.assertString("3k9em70_j0Ac", label_ ? "utm_campaign" + ": " + label_ : "utm_campaign", utmCampaign));
    }
    return messages;
  }
  
  function assertSchema(schema, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4-eTlbcITN", label_ ? "schema" + ": " + label_ : "schema", schema));
    if ("iglu:nl.ns/login_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/login_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/view/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cart_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/chat_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/checkout_progress/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/checkout_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/content_share/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/experiment_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/file_download/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/form_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/form_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/item_select/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/item_view/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/lead_generate/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/nba_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/page_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/push_consent/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/registration_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/registration_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/scroll/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/search_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/video_complete/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/video_progress/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/video_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/visit_qualified/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_clear_data/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/purchase_intention/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/session_count/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/session_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/form_submit/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/widget_add/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/widget_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/station/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/detail_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/kaart_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/modalities_filter/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/traject_add/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/traject_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/traject_seintjes/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_receive/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_open/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_foreground/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_dismiss/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_exception/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_update/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/os_update/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/server_purchase/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/login_success/jsonschema/2-0-3" !== schema &&
        "iglu:nl.ns/page/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2" !== schema &&
        "iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2" !== schema &&
        "iglu:nl.ns/login_status_update/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/class_change_confirm/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/class_change_set/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/nba_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/screen_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/feedback_give/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/global_contexts_add/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/page_context/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/consent_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/global_contexts/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-0-7" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/authentication/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/banner_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/cart_add/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/checkbox_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/chip_filter_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/clicked_option/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/datepicker_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/element_click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/element_view/jsonschema/4-0-2" !== schema &&
        "iglu:nl.ns/error/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/expandable_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/experiment_view/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/link_click/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/logout_success/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/nba_view/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/page_view/jsonschema/4-0-3" !== schema &&
        "iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/search_view_results/jsonschema/2-0-3" !== schema &&
        "iglu:nl.ns/select_click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/selectable_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/server_experiments/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/subscription_change/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/subscription_change_select/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/toggle_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/tooltip_click/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/button_click/jsonschema/2-0-6" !== schema &&
        "iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/add_payment_info/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/1-0-6" !== schema &&
        "iglu:nl.ns/begin_checkout/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-7" !== schema &&
        "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/view_item/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/view_item_list/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0" !== schema) {
      var message = (label_ ? "schema" + ": " + label_ : "schema") + " should match one of the following values [ iglu:nl.ns/login_start/jsonschema/1-0-0 | iglu:nl.ns/login_error/jsonschema/1-0-0 | iglu:nl.ns/view/jsonschema/1-0-0 | iglu:nl.ns/cart_remove/jsonschema/1-0-0 | iglu:nl.ns/chat_start/jsonschema/1-0-0 | iglu:nl.ns/checkout_progress/jsonschema/1-0-0 | iglu:nl.ns/checkout_start/jsonschema/1-0-0 | iglu:nl.ns/content_share/jsonschema/1-0-0 | iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0 | iglu:nl.ns/experiment_success/jsonschema/1-0-0 | iglu:nl.ns/file_download/jsonschema/1-0-0 | iglu:nl.ns/form_error/jsonschema/1-0-0 | iglu:nl.ns/form_start/jsonschema/1-0-0 | iglu:nl.ns/item_select/jsonschema/1-0-0 | iglu:nl.ns/item_view/jsonschema/1-0-0 | iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0 | iglu:nl.ns/lead_generate/jsonschema/1-0-0 | iglu:nl.ns/nba_success/jsonschema/1-0-0 | iglu:nl.ns/page_error/jsonschema/1-0-0 | iglu:nl.ns/push_consent/jsonschema/1-0-0 | iglu:nl.ns/registration_start/jsonschema/1-0-0 | iglu:nl.ns/registration_success/jsonschema/1-0-0 | iglu:nl.ns/reisplanner_error/jsonschema/1-0-0 | iglu:nl.ns/reisplanner_success/jsonschema/1-0-0 | iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0 | iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0 | iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0 | iglu:nl.ns/scroll/jsonschema/1-0-0 | iglu:nl.ns/search_start/jsonschema/1-0-0 | iglu:nl.ns/video_complete/jsonschema/1-0-0 | iglu:nl.ns/video_progress/jsonschema/1-0-0 | iglu:nl.ns/video_start/jsonschema/1-0-0 | iglu:nl.ns/visit_qualified/jsonschema/1-0-0 | iglu:nl.ns/app_clear_data/jsonschema/1-0-0 | iglu:nl.ns/purchase_intention/jsonschema/1-0-0 | iglu:nl.ns/session_count/jsonschema/1-0-0 | iglu:nl.ns/session_start/jsonschema/1-0-0 | iglu:nl.ns/form_submit/jsonschema/1-0-0 | iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0 | iglu:nl.ns/widget_add/jsonschema/1-0-0 | iglu:nl.ns/widget_remove/jsonschema/1-0-0 | iglu:nl.ns/station/jsonschema/1-0-0 | iglu:nl.ns/detail_click/jsonschema/1-0-0 | iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0 | iglu:nl.ns/kaart_click/jsonschema/1-0-0 | iglu:nl.ns/modalities_filter/jsonschema/1-0-0 | iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0 | iglu:nl.ns/traject_add/jsonschema/1-0-0 | iglu:nl.ns/traject_remove/jsonschema/1-0-0 | iglu:nl.ns/traject_seintjes/jsonschema/1-0-0 | iglu:nl.ns/notification_receive/jsonschema/1-0-0 | iglu:nl.ns/notification_open/jsonschema/1-0-0 | iglu:nl.ns/notification_foreground/jsonschema/1-0-0 | iglu:nl.ns/notification_dismiss/jsonschema/1-0-0 | iglu:nl.ns/app_exception/jsonschema/1-0-0 | iglu:nl.ns/app_remove/jsonschema/1-0-0 | iglu:nl.ns/app_update/jsonschema/1-0-0 | iglu:nl.ns/os_update/jsonschema/1-0-0 | iglu:nl.ns/server_purchase/jsonschema/1-0-0 | iglu:nl.ns/remove_from_cart/jsonschema/1-0-0 | iglu:nl.ns/login_success/jsonschema/2-0-3 | iglu:nl.ns/page/jsonschema/1-0-0 | iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2 | iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2 | iglu:nl.ns/login_status_update/jsonschema/1-0-0 | iglu:nl.ns/class_change_confirm/jsonschema/1-0-0 | iglu:nl.ns/class_change_set/jsonschema/1-0-0 | iglu:nl.ns/nba_context/jsonschema/1-0-0 | iglu:nl.ns/screen_context/jsonschema/1-0-0 | iglu:nl.ns/feedback_give/jsonschema/1-0-2 | iglu:nl.ns/global_contexts_add/jsonschema/1-0-0 | iglu:nl.ns/page_context/jsonschema/1-0-1 | iglu:nl.ns/consent_context/jsonschema/1-0-0 | iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0 | iglu:nl.ns/global_contexts/jsonschema/1-0-0 | iglu:nl.ns/screen_view/jsonschema/1-0-7 | iglu:nl.ns/add_to_cart/jsonschema/1-0-5 | iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0 | iglu:nl.ns/authentication/jsonschema/1-0-0 | iglu:nl.ns/banner_click/jsonschema/1-0-3 | iglu:nl.ns/cart_add/jsonschema/1-0-3 | iglu:nl.ns/checkbox_click/jsonschema/1-0-3 | iglu:nl.ns/chip_filter_click/jsonschema/1-0-3 | iglu:nl.ns/click/jsonschema/1-0-2 | iglu:nl.ns/clicked_option/jsonschema/1-0-1 | iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2 | iglu:nl.ns/datepicker_click/jsonschema/1-0-3 | iglu:nl.ns/element_click/jsonschema/1-0-2 | iglu:nl.ns/element_view/jsonschema/4-0-2 | iglu:nl.ns/error/jsonschema/1-0-1 | iglu:nl.ns/expandable_click/jsonschema/1-0-3 | iglu:nl.ns/experiment_view/jsonschema/1-0-5 | iglu:nl.ns/link_click/jsonschema/1-0-1 | iglu:nl.ns/logout_success/jsonschema/1-0-1 | iglu:nl.ns/nba_audience_add/jsonschema/1-0-1 | iglu:nl.ns/nba_view/jsonschema/1-0-3 | iglu:nl.ns/page_view/jsonschema/4-0-3 | iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3 | iglu:nl.ns/search_view_results/jsonschema/2-0-3 | iglu:nl.ns/select_click/jsonschema/1-0-2 | iglu:nl.ns/selectable_click/jsonschema/1-0-3 | iglu:nl.ns/server_experiments/jsonschema/1-0-1 | iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1 | iglu:nl.ns/subscription_change/jsonschema/1-0-1 | iglu:nl.ns/subscription_change_select/jsonschema/1-0-2 | iglu:nl.ns/toggle_click/jsonschema/1-0-3 | iglu:nl.ns/tooltip_click/jsonschema/1-0-4 | iglu:nl.ns/button_click/jsonschema/2-0-6 | iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0 | iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0 | iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0 | iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0 | iglu:nl.ns/add_payment_info/jsonschema/1-0-2 | iglu:nl.ns/add_shipping_info/jsonschema/1-0-2 | iglu:nl.ns/add_to_cart/jsonschema/1-0-6 | iglu:nl.ns/begin_checkout/jsonschema/1-0-2 | iglu:nl.ns/purchase/jsonschema/2-0-7 | iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4 | iglu:nl.ns/view_item/jsonschema/1-0-2 | iglu:nl.ns/view_item_list/jsonschema/1-0-2 | iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1 | iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0 | iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0 | iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0 | iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0 | iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0 ] but you provided the value " + schema
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "4-eTlbcITN", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalUtmSource(utmSource, label_) {
    var messages = [];
    if (utmSource !== undefined && utmSource !== null) {
      messages = messages.concat(AvoAssert.assertString("4X73rTMNgTkZ", label_ ? "utm_source" + ": " + label_ : "utm_source", utmSource));
    }
    return messages;
  }
  
  function assertOptionalFeedbackType(feedbackType, label_) {
    var messages = [];
    if (feedbackType !== undefined && feedbackType !== null) {
      messages = messages.concat(AvoAssert.assertString("5EE-BUb_w", label_ ? "feedback_type" + ": " + label_ : "feedback_type", feedbackType));
    }
    return messages;
  }
  
  function assertVideoUrl(videoUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5W6xoSKVWDn2", label_ ? "video_url" + ": " + label_ : "video_url", videoUrl));
    return messages;
  }
  
  function assertChatInitiator(chatInitiator, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5pRtByAXn", label_ ? "chat_initiator" + ": " + label_ : "chat_initiator", chatInitiator));
    if ("click" !== chatInitiator &&
        "hover" !== chatInitiator &&
        "previous_chat_session" !== chatInitiator &&
        "time_delay" !== chatInitiator) {
      var message = (label_ ? "chat_initiator" + ": " + label_ : "chat_initiator") + " should match one of the following values [ click | hover | previous_chat_session | time_delay ] but you provided the value " + chatInitiator
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "5pRtByAXn", message: message}]);
    }
    return messages;
  }
  
  function assertItemBrand(itemBrand, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("6-GUnFHLFL", label_ ? "item_brand" + ": " + label_ : "item_brand", itemBrand));
    return messages;
  }
  
  function assertOptionalItemBrand(itemBrand, label_) {
    var messages = [];
    if (itemBrand !== undefined && itemBrand !== null) {
      messages = messages.concat(AvoAssert.assertString("6-GUnFHLFL", label_ ? "item_brand" + ": " + label_ : "item_brand", itemBrand));
    }
    return messages;
  }
  
  function assertOptionalData(data, label_) {
    var messages = [];
    if (data !== undefined && data !== null) {
      messages = messages.concat(AvoAssert.assertString("7HGUvDZb-Fax", label_ ? "data" + ": " + label_ : "data", data));
    }
    return messages;
  }
  
  function assertErrorCategory(errorCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7Nf2EeEBl", label_ ? "error_category" + ": " + label_ : "error_category", errorCategory));
    return messages;
  }
  
  function assertUcVariant(ucVariant, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7OXAcO_7A", label_ ? "uc_variant" + ": " + label_ : "uc_variant", ucVariant));
    return messages;
  }
  
  function assertQuestion(question, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7f5ty_nULaWo", label_ ? "question" + ": " + label_ : "question", question));
    return messages;
  }
  
  function assertItemCategory(itemCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7h-TV9MOq2", label_ ? "item_category" + ": " + label_ : "item_category", itemCategory));
    return messages;
  }
  
  function assertOptionalItemCategory(itemCategory, label_) {
    var messages = [];
    if (itemCategory !== undefined && itemCategory !== null) {
      messages = messages.concat(AvoAssert.assertString("7h-TV9MOq2", label_ ? "item_category" + ": " + label_ : "item_category", itemCategory));
    }
    return messages;
  }
  
  function assertFormDestination(formDestination, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("83KZlBXgHnFi", label_ ? "form_destination" + ": " + label_ : "form_destination", formDestination));
    return messages;
  }
  
  function assertOptionOnlyLocalTrains(optionOnlyLocalTrains, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("8jofQf9ETeBe", label_ ? "option_only_local_trains" + ": " + label_ : "option_only_local_trains", optionOnlyLocalTrains));
    return messages;
  }
  
  function assertCoupon(coupon, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9Tv-BxH6jSI", label_ ? "coupon" + ": " + label_ : "coupon", coupon));
    return messages;
  }
  
  function assertOptionalCoupon(coupon, label_) {
    var messages = [];
    if (coupon !== undefined && coupon !== null) {
      messages = messages.concat(AvoAssert.assertString("9Tv-BxH6jSI", label_ ? "coupon" + ": " + label_ : "coupon", coupon));
    }
    return messages;
  }
  
  function assertHashedEmail(hashedEmail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ALoQI7FpkV", label_ ? "hashed_email" + ": " + label_ : "hashed_email", hashedEmail));
    return messages;
  }
  
  function assertLanguage(language, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Af3-RL1nz2", label_ ? "language" + ": " + label_ : "language", language));
    if ("nl" !== language &&
        "en" !== language) {
      var message = (label_ ? "language" + ": " + label_ : "language") + " should match one of the following values [ nl | en ] but you provided the value " + language
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Af3-RL1nz2", message: message}]);
    }
    return messages;
  }
  
  function assertUcLocation(ucLocation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Am6PkQ_Uo", label_ ? "uc_location" + ": " + label_ : "uc_location", ucLocation));
    return messages;
  }
  
  function assertChatTool(chatTool, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("B7jES2_im", label_ ? "chat_tool" + ": " + label_ : "chat_tool", chatTool));
    return messages;
  }
  
  function assertNsShop(nsShop, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BImlhIesBPhx", label_ ? "ns_shop" + ": " + label_ : "ns_shop", nsShop));
    if ("ns_businesscard" !== nsShop &&
        "spoordeelwinkel" !== nsShop &&
        "abonnementen" !== nsShop &&
        "losse_vervoersbewijzen" !== nsShop &&
        "lvb_kaartjes" !== nsShop &&
        "lvb_app" !== nsShop &&
        "ns-flex" !== nsShop) {
      var message = (label_ ? "ns_shop" + ": " + label_ : "ns_shop") + " should match one of the following values [ ns_businesscard | spoordeelwinkel | abonnementen | losse_vervoersbewijzen | lvb_kaartjes | lvb_app | ns-flex ] but you provided the value " + nsShop
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BImlhIesBPhx", message: message}]);
    }
    return messages;
  }
  
  function assertFeedbackPlatform(feedbackPlatform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BRMFCaolHInZ", label_ ? "feedback_platform" + ": " + label_ : "feedback_platform", feedbackPlatform));
    if ("usabilla" !== feedbackPlatform &&
        "getfeedback" !== feedbackPlatform &&
        "qualtrics" !== feedbackPlatform) {
      var message = (label_ ? "feedback_platform" + ": " + label_ : "feedback_platform") + " should match one of the following values [ usabilla | getfeedback | qualtrics ] but you provided the value " + feedbackPlatform
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BRMFCaolHInZ", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalUtmId(utmId, label_) {
    var messages = [];
    if (utmId !== undefined && utmId !== null) {
      messages = messages.concat(AvoAssert.assertString("BXSsSA9Tphqq", label_ ? "utm_id" + ": " + label_ : "utm_id", utmId));
    }
    return messages;
  }
  
  function assertClickType(clickType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BxxFgWL7KfAD", label_ ? "click_type" + ": " + label_ : "click_type", clickType));
    return messages;
  }
  
  function assertVideoCurrentTime(videoCurrentTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("C3vfalxpU8Ib", label_ ? "video_current_time" + ": " + label_ : "video_current_time", videoCurrentTime));
    return messages;
  }
  
  function assertOptionalOptionTransportOptions(optionTransportOptions, label_) {
    var messages = [];
    if (optionTransportOptions !== undefined && optionTransportOptions !== null) {
      messages = messages.concat(AvoAssert.assertString("CaMQ0XJCJbKL", label_ ? "option_transport_options" + ": " + label_ : "option_transport_options", optionTransportOptions));
    }
    return messages;
  }
  
  function assertAffiliation(affiliation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("D-6RH3lvH", label_ ? "affiliation" + ": " + label_ : "affiliation", affiliation));
    return messages;
  }
  
  function assertOptionalAffiliation(affiliation, label_) {
    var messages = [];
    if (affiliation !== undefined && affiliation !== null) {
      messages = messages.concat(AvoAssert.assertString("D-6RH3lvH", label_ ? "affiliation" + ": " + label_ : "affiliation", affiliation));
    }
    return messages;
  }
  
  function assertVideoTitle(videoTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("E29-6P-mJPC9", label_ ? "video_title" + ": " + label_ : "video_title", videoTitle));
    return messages;
  }
  
  function assertOptionalOptionExtraTransferTime(optionExtraTransferTime, label_) {
    var messages = [];
    if (optionExtraTransferTime !== undefined && optionExtraTransferTime !== null) {
      messages = messages.concat(AvoAssert.assertInt("EhTR7EnR_4-n", label_ ? "option_extra_transfer_time" + ": " + label_ : "option_extra_transfer_time", optionExtraTransferTime));
    }
    return messages;
  }
  
  function assertAnswer(answer, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("F4RDcFwudL0_", label_ ? "answer" + ": " + label_ : "answer", answer));
    return messages;
  }
  
  function assertTestTool(testTool, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GL_TSnWYyKgW", label_ ? "test_tool" + ": " + label_ : "test_tool", testTool));
    return messages;
  }
  
  function assertOptionalExistingProduct(existingProduct, label_) {
    var messages = [];
    if (existingProduct !== undefined && existingProduct !== null) {
      messages = messages.concat(AvoAssert.assertList("GsMr_TucEDqV", "existing_product", existingProduct));
      existingProduct.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertObject("GsMr_TucEDqV", "item at index " + index + " in existing_product", value));
        messages = messages.concat(assertItemId(value.itemId, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertItemName(value.itemName, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemCategory(value.itemCategory, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemCategory2(value.itemCategory2, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertPrice(value.price, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemBrand(value.itemBrand, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemVariant(value.itemVariant, "item at index " + index + " in existing_product"));
      });
    }
    return messages;
  }
  
  function assertCurrency(currency, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GuYrcDncVS5", label_ ? "currency" + ": " + label_ : "currency", currency));
    if ("EUR" !== currency) {
      var message = (label_ ? "currency" + ": " + label_ : "currency") + " should match one of the following values [ EUR ] but you provided the value " + currency
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "GuYrcDncVS5", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalClickId1(clickId1, label_) {
    var messages = [];
    if (clickId1 !== undefined && clickId1 !== null) {
      messages = messages.concat(AvoAssert.assertString("HolZTTkkioUB", label_ ? "click_id" + ": " + label_ : "click_id", clickId1));
    }
    return messages;
  }
  
  function assertTestId(testId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HpghA4STUpM1", label_ ? "test_id" + ": " + label_ : "test_id", testId));
    return messages;
  }
  
  function assertVideoProvider1(videoProvider1, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Hx_El_YtO-Wk", label_ ? "video_provider" + ": " + label_ : "video_provider", videoProvider1));
    return messages;
  }
  
  function assertTestVariant(testVariant, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("I44jVDyqBZic", label_ ? "test_variant" + ": " + label_ : "test_variant", testVariant));
    return messages;
  }
  
  function assertOptionalTax(tax, label_) {
    var messages = [];
    if (tax !== undefined && tax !== null) {
      messages = messages.concat(AvoAssert.assertFloat("IBS3IO629xIC", label_ ? "tax" + ": " + label_ : "tax", tax));
    }
    return messages;
  }
  
  function assertOriginType(originType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("JhQcIHY4C9pI", label_ ? "origin_type" + ": " + label_ : "origin_type", originType));
    if ("station" !== originType &&
        "address" !== originType &&
        "stop" !== originType &&
        "poi" !== originType &&
        "unknown" !== originType) {
      var message = (label_ ? "origin_type" + ": " + label_ : "origin_type") + " should match one of the following values [ station | address | stop | poi | unknown ] but you provided the value " + originType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "JhQcIHY4C9pI", message: message}]);
    }
    return messages;
  }
  
  function assertDeurTotDeur(deurTotDeur, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("JzW147FWP", "deur_tot_deur", deurTotDeur));
    if (deurTotDeur !== null && deurTotDeur !== undefined && deurTotDeur.forEach) {
      deurTotDeur.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalDeurTotDeur(deurTotDeur, label_) {
    var messages = [];
    if (deurTotDeur !== undefined && deurTotDeur !== null) {
      messages = messages.concat(AvoAssert.assertList("JzW147FWP", "deur_tot_deur", deurTotDeur));
      deurTotDeur.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertClickClasses(clickClasses, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("K5J4L8efdGgl", label_ ? "click_classes" + ": " + label_ : "click_classes", clickClasses));
    return messages;
  }
  
  function assertDestination(destination, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("K5UKR3Wbe9xC", label_ ? "destination" + ": " + label_ : "destination", destination));
    return messages;
  }
  
  function assertVideoPercent(videoPercent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("KtXvxPrGGhXA", label_ ? "video_percent" + ": " + label_ : "video_percent", videoPercent));
    return messages;
  }
  
  function assertDatalayerSource(datalayerSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("L-rHlXDQJd", label_ ? "datalayer_source" + ": " + label_ : "datalayer_source", datalayerSource));
    return messages;
  }
  
  function assertOptionalItemListName(itemListName, label_) {
    var messages = [];
    if (itemListName !== undefined && itemListName !== null) {
      messages = messages.concat(AvoAssert.assertString("LydSjYynFBlR", label_ ? "item_list_name" + ": " + label_ : "item_list_name", itemListName));
      if ("Kaartjes" !== itemListName &&
          "NSBC" !== itemListName) {
        var message = (label_ ? "item_list_name" + ": " + label_ : "item_list_name") + " should match one of the following values [ Kaartjes | NSBC ] but you provided the value " + itemListName
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "LydSjYynFBlR", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalOriginModalities(originModalities, label_) {
    var messages = [];
    if (originModalities !== undefined && originModalities !== null) {
      messages = messages.concat(AvoAssert.assertString("MgmcZ65PSEiQ", label_ ? "origin_modalities" + ": " + label_ : "origin_modalities", originModalities));
    }
    return messages;
  }
  
  function assertOptionalTicketClass(ticketClass, label_) {
    var messages = [];
    if (ticketClass !== undefined && ticketClass !== null) {
      messages = messages.concat(AvoAssert.assertString("OPP6AeYDy", label_ ? "ticket_class" + ": " + label_ : "ticket_class", ticketClass));
    }
    return messages;
  }
  
  function assertItems(items, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("Oavl4KfPHF3", "items", items));
    if (items !== null && items !== undefined && items.forEach) {
      items.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertObject("Oavl4KfPHF3", "item at index " + index + " in items", value));
        messages = messages.concat(assertItemId(value.itemId, "item at index " + index + " in items"));
        messages = messages.concat(assertItemName(value.itemName, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalCoupon(value.coupon, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalDiscount(value.discount, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalIndex(value.index, "item at index " + index + " in items"));
        messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in items"));
        messages = messages.concat(assertPrice(value.price, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemBrand(value.itemBrand, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemVariant(value.itemVariant, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemCategory(value.itemCategory, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTravelDate(value.travelDate, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTicketClass(value.ticketClass, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalAffiliation(value.affiliation, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemCategory2(value.itemCategory2, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalDestinationStation(value.destinationStation, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalOriginStation(value.originStation, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTravelClass(value.travelClass, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTravelRoute(value.travelRoute, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalIntercityDirect(value.intercityDirect, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalDeurTotDeur(value.deurTotDeur, "item at index " + index + " in items"));
      });
    }
    return messages;
  }
  
  function assertError(error, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Oi6yaZll3yFM", label_ ? "error" + ": " + label_ : "error", error));
    return messages;
  }
  
  function assertIndex(index, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("PKlIwCNeHb", label_ ? "index" + ": " + label_ : "index", index));
    return messages;
  }
  
  function assertOptionalIndex(index, label_) {
    var messages = [];
    if (index !== undefined && index !== null) {
      messages = messages.concat(AvoAssert.assertInt("PKlIwCNeHb", label_ ? "index" + ": " + label_ : "index", index));
    }
    return messages;
  }
  
  function assertOptionalPreview(preview, label_) {
    var messages = [];
    if (preview !== undefined && preview !== null) {
      messages = messages.concat(AvoAssert.assertBool("Po4mUsQEyB", label_ ? "preview" + ": " + label_ : "preview", preview));
    }
    return messages;
  }
  
  function assertTravelRoute(travelRoute, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PpX-d_0VW", label_ ? "travel_route" + ": " + label_ : "travel_route", travelRoute));
    return messages;
  }
  
  function assertOptionalTravelRoute(travelRoute, label_) {
    var messages = [];
    if (travelRoute !== undefined && travelRoute !== null) {
      messages = messages.concat(AvoAssert.assertString("PpX-d_0VW", label_ ? "travel_route" + ": " + label_ : "travel_route", travelRoute));
    }
    return messages;
  }
  
  function assertFileName(fileName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PqLRY8g1AK7Q", label_ ? "file_name" + ": " + label_ : "file_name", fileName));
    return messages;
  }
  
  function assertPlanDate(planDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QrQ2jdtpI42P", label_ ? "plan_date" + ": " + label_ : "plan_date", planDate));
    return messages;
  }
  
  function assertTransactionId(transactionId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SCki6fM2wea", label_ ? "transaction_id" + ": " + label_ : "transaction_id", transactionId));
    return messages;
  }
  
  function assertTestLocation(testLocation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TDtygjQ3jTuJ", label_ ? "test_location" + ": " + label_ : "test_location", testLocation));
    return messages;
  }
  
  function assertOptionalTestLocation(testLocation, label_) {
    var messages = [];
    if (testLocation !== undefined && testLocation !== null) {
      messages = messages.concat(AvoAssert.assertString("TDtygjQ3jTuJ", label_ ? "test_location" + ": " + label_ : "test_location", testLocation));
    }
    return messages;
  }
  
  function assertClickText(clickText, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TFD27fnuBpN-", label_ ? "click_text" + ": " + label_ : "click_text", clickText));
    return messages;
  }
  
  function assertItemCategory2(itemCategory2, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TIV1Wo8BM", label_ ? "item_category2" + ": " + label_ : "item_category2", itemCategory2));
    return messages;
  }
  
  function assertOptionalItemCategory2(itemCategory2, label_) {
    var messages = [];
    if (itemCategory2 !== undefined && itemCategory2 !== null) {
      messages = messages.concat(AvoAssert.assertString("TIV1Wo8BM", label_ ? "item_category2" + ": " + label_ : "item_category2", itemCategory2));
    }
    return messages;
  }
  
  function assertOptionalCustomerEntity(customerEntity, label_) {
    var messages = [];
    if (customerEntity !== undefined && customerEntity !== null) {
      messages = messages.concat(AvoAssert.assertString("TQleINBSI93G", label_ ? "customer_entity" + ": " + label_ : "customer_entity", customerEntity));
      if ("kaarthouder" !== customerEntity &&
          "contactpersoon" !== customerEntity) {
        var message = (label_ ? "customer_entity" + ": " + label_ : "customer_entity") + " should match one of the following values [ kaarthouder | contactpersoon ] but you provided the value " + customerEntity
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "TQleINBSI93G", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalUtmTerm(utmTerm, label_) {
    var messages = [];
    if (utmTerm !== undefined && utmTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("TigsIVrjd8Ws", label_ ? "utm_term" + ": " + label_ : "utm_term", utmTerm));
    }
    return messages;
  }
  
  function assertFileExtension(fileExtension, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TizyQU9Eo2GE", label_ ? "file_extension" + ": " + label_ : "file_extension", fileExtension));
    return messages;
  }
  
  function assertOptionalDestinationStation(destinationStation, label_) {
    var messages = [];
    if (destinationStation !== undefined && destinationStation !== null) {
      messages = messages.concat(AvoAssert.assertString("UpRgfCPRK", label_ ? "destination_station" + ": " + label_ : "destination_station", destinationStation));
    }
    return messages;
  }
  
  function assertOptionalUtmMedium(utmMedium, label_) {
    var messages = [];
    if (utmMedium !== undefined && utmMedium !== null) {
      messages = messages.concat(AvoAssert.assertString("WCgPbfCy_8b3", label_ ? "utm_medium" + ": " + label_ : "utm_medium", utmMedium));
    }
    return messages;
  }
  
  function assertOptionNoReservation(optionNoReservation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("WDi4lr0fPar_", label_ ? "option_no_reservation" + ": " + label_ : "option_no_reservation", optionNoReservation));
    return messages;
  }
  
  function assertTravelDate(travelDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("WGDHyEYby", label_ ? "travel_date" + ": " + label_ : "travel_date", travelDate));
    return messages;
  }
  
  function assertOptionalTravelDate(travelDate, label_) {
    var messages = [];
    if (travelDate !== undefined && travelDate !== null) {
      messages = messages.concat(AvoAssert.assertString("WGDHyEYby", label_ ? "travel_date" + ": " + label_ : "travel_date", travelDate));
    }
    return messages;
  }
  
  function assertOptionalFeedbackName(feedbackName, label_) {
    var messages = [];
    if (feedbackName !== undefined && feedbackName !== null) {
      messages = messages.concat(AvoAssert.assertString("Xhkk5MHMs", label_ ? "feedback_name" + ": " + label_ : "feedback_name", feedbackName));
    }
    return messages;
  }
  
  function assertOptionalTestAudienceId(testAudienceId, label_) {
    var messages = [];
    if (testAudienceId !== undefined && testAudienceId !== null) {
      messages = messages.concat(AvoAssert.assertString("Xiuci0NEjDkz", label_ ? "test_audience_id" + ": " + label_ : "test_audience_id", testAudienceId));
    }
    return messages;
  }
  
  function assertTeamName(teamName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("XoZ_JHMfu", label_ ? "team_name" + ": " + label_ : "team_name", teamName));
    return messages;
  }
  
  function assertClickDestination(clickDestination, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ZRYtNJDfVeyb", label_ ? "click_destination" + ": " + label_ : "click_destination", clickDestination));
    return messages;
  }
  
  function assertOptionalItemId(itemId, label_) {
    var messages = [];
    if (itemId !== undefined && itemId !== null) {
      messages = messages.concat(AvoAssert.assertString("ZVGAZOlEBhGj", label_ ? "item_id" + ": " + label_ : "item_id", itemId));
    }
    return messages;
  }
  
  function assertItemId(itemId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ZVGAZOlEBhGj", label_ ? "item_id" + ": " + label_ : "item_id", itemId));
    return messages;
  }
  
  function assertQuantity(quantity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ZZlWcbau6V", label_ ? "quantity" + ": " + label_ : "quantity", quantity));
    return messages;
  }
  
  function assertOptionalBankSelected(bankSelected, label_) {
    var messages = [];
    if (bankSelected !== undefined && bankSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("_8eP6aJ0U", label_ ? "bank_selected" + ": " + label_ : "bank_selected", bankSelected));
    }
    return messages;
  }
  
  function assertPrice(price, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("_T-mygJA7w", label_ ? "price" + ": " + label_ : "price", price));
    return messages;
  }
  
  function assertErrorMessage(errorMessage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("_UC5Zg5bYPN", "error_message", errorMessage));
    if (errorMessage !== null && errorMessage !== undefined && errorMessage.forEach) {
      errorMessage.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertTravelClass(travelClass, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_WmY6XGTY", label_ ? "travel_class" + ": " + label_ : "travel_class", travelClass));
    return messages;
  }
  
  function assertOptionalTravelClass(travelClass, label_) {
    var messages = [];
    if (travelClass !== undefined && travelClass !== null) {
      messages = messages.concat(AvoAssert.assertString("_WmY6XGTY", label_ ? "travel_class" + ": " + label_ : "travel_class", travelClass));
    }
    return messages;
  }
  
  function assertPercent(percent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_iIBN-4DdOc1", label_ ? "percent" + ": " + label_ : "percent", percent));
    return messages;
  }
  
  function assertCluster(cluster, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("aF92rWblhlD9", label_ ? "cluster" + ": " + label_ : "cluster", cluster));
    if ("abo" !== cluster &&
        "lvb" !== cluster &&
        "nsi" !== cluster &&
        "ovk" !== cluster &&
        "rcr" !== cluster) {
      var message = (label_ ? "cluster" + ": " + label_ : "cluster") + " should match one of the following values [ abo | lvb | nsi | ovk | rcr ] but you provided the value " + cluster
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "aF92rWblhlD9", message: message}]);
    }
    return messages;
  }
  
  function assertMinutesToPlanTime(minutesToPlanTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("aI7_g6oQRfSk", label_ ? "minutes_to_plan_time" + ": " + label_ : "minutes_to_plan_time", minutesToPlanTime));
    return messages;
  }
  
  function assertUserId_(userId_, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("avo-enriched-type-user-id", label_ ? "User Id" + ": " + label_ : "User Id", userId_));
    return messages;
  }
  
  function assertOptionalPermissions(permissions, label_) {
    var messages = [];
    if (permissions !== undefined && permissions !== null) {
      messages = messages.concat(AvoAssert.assertList("b6ebejYlEx2Y", "permissions", permissions));
      permissions.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertPermissions(permissions, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("b6ebejYlEx2Y", "permissions", permissions));
    if (permissions !== null && permissions !== undefined && permissions.forEach) {
      permissions.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalOriginStation(originStation, label_) {
    var messages = [];
    if (originStation !== undefined && originStation !== null) {
      messages = messages.concat(AvoAssert.assertString("bMK3liq6t", label_ ? "origin_station" + ": " + label_ : "origin_station", originStation));
    }
    return messages;
  }
  
  function assertOptionalDiscount(discount, label_) {
    var messages = [];
    if (discount !== undefined && discount !== null) {
      messages = messages.concat(AvoAssert.assertFloat("ePZR23byGW", label_ ? "discount" + ": " + label_ : "discount", discount));
    }
    return messages;
  }
  
  function assertArrivalOrDepartureDate(arrivalOrDepartureDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("fei9WfaoV0KU", label_ ? "arrival_or_departure_date" + ": " + label_ : "arrival_or_departure_date", arrivalOrDepartureDate));
    return messages;
  }
  
  function assertFormName(formName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gL1cdb__7Q9c", label_ ? "form_name" + ": " + label_ : "form_name", formName));
    return messages;
  }
  
  function assertUcId(ucId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gbSQirnPl", label_ ? "uc_id" + ": " + label_ : "uc_id", ucId));
    return messages;
  }
  
  function assertItemName(itemName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hg4puJyLhb", label_ ? "item_name" + ": " + label_ : "item_name", itemName));
    return messages;
  }
  
  function assertPlanTime(planTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hi8osDXdCJVA", label_ ? "plan_time" + ": " + label_ : "plan_time", planTime));
    return messages;
  }
  
  function assertTestTeam(testTeam, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ij0L0WRQXuPq", label_ ? "test_team" + ": " + label_ : "test_team", testTeam));
    return messages;
  }
  
  function assertOptionalChatClickSource(chatClickSource, label_) {
    var messages = [];
    if (chatClickSource !== undefined && chatClickSource !== null) {
      messages = messages.concat(AvoAssert.assertString("j8qPJcH-G", label_ ? "chat_click_source" + ": " + label_ : "chat_click_source", chatClickSource));
      if ("button" !== chatClickSource &&
          "cancellation_link" !== chatClickSource &&
          "chat_link" !== chatClickSource &&
          "live_chat" !== chatClickSource) {
        var message = (label_ ? "chat_click_source" + ": " + label_ : "chat_click_source") + " should match one of the following values [ button | cancellation_link | chat_link | live_chat ] but you provided the value " + chatClickSource
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "j8qPJcH-G", message: message}]);
      }
    }
    return messages;
  }
  
  function assertContentType(contentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("jbSdZ_YNpuuA", label_ ? "content_type" + ": " + label_ : "content_type", contentType));
    return messages;
  }
  
  function assertOptionalUtmContent(utmContent, label_) {
    var messages = [];
    if (utmContent !== undefined && utmContent !== null) {
      messages = messages.concat(AvoAssert.assertString("jksVIoRXIWk2", label_ ? "utm_content" + ": " + label_ : "utm_content", utmContent));
    }
    return messages;
  }
  
  function assertWebsiteVersion(websiteVersion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l4YWQepFGqt9", label_ ? "website_version" + ": " + label_ : "website_version", websiteVersion));
    if ("consument" !== websiteVersion &&
        "zakelijk" !== websiteVersion) {
      var message = (label_ ? "website_version" + ": " + label_ : "website_version") + " should match one of the following values [ consument | zakelijk ] but you provided the value " + websiteVersion
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "l4YWQepFGqt9", message: message}]);
    }
    return messages;
  }
  
  function assertMijnnsVersion(mijnnsVersion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("lbXiVJSEQrn6", label_ ? "mijnns_version" + ": " + label_ : "mijnns_version", mijnnsVersion));
    if ("mijnns" !== mijnnsVersion &&
        "mijnns_zakelijk" !== mijnnsVersion) {
      var message = (label_ ? "mijnns_version" + ": " + label_ : "mijnns_version") + " should match one of the following values [ mijnns | mijnns_zakelijk ] but you provided the value " + mijnnsVersion
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "lbXiVJSEQrn6", message: message}]);
    }
    return messages;
  }
  
  function assertTicketPrice(ticketPrice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("lztkT6sWa2HW", label_ ? "ticket_price" + ": " + label_ : "ticket_price", ticketPrice));
    return messages;
  }
  
  function assertPushConsentStatus(pushConsentStatus, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("mE3yslcjncEm", "push_consent_status", pushConsentStatus));
    if (pushConsentStatus !== null && pushConsentStatus !== undefined && pushConsentStatus.forEach) {
      pushConsentStatus.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalOptionViaStation(optionViaStation, label_) {
    var messages = [];
    if (optionViaStation !== undefined && optionViaStation !== null) {
      messages = messages.concat(AvoAssert.assertString("nXtf5xu83rju", label_ ? "option_via_station" + ": " + label_ : "option_via_station", optionViaStation));
    }
    return messages;
  }
  
  function assertOptionalOrigin(origin, label_) {
    var messages = [];
    if (origin !== undefined && origin !== null) {
      messages = messages.concat(AvoAssert.assertString("oyE5fJGQ8YEf", label_ ? "origin" + ": " + label_ : "origin", origin));
    }
    return messages;
  }
  
  function assertOptionalTestDescription(testDescription, label_) {
    var messages = [];
    if (testDescription !== undefined && testDescription !== null) {
      messages = messages.concat(AvoAssert.assertString("pnPG0qR_-", label_ ? "test_description" + ": " + label_ : "test_description", testDescription));
    }
    return messages;
  }
  
  function assertDestinationType(destinationType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pzgV0n5Ze47t", label_ ? "destination_type" + ": " + label_ : "destination_type", destinationType));
    if ("station" !== destinationType &&
        "address" !== destinationType &&
        "stop" !== destinationType &&
        "poi" !== destinationType &&
        "unknown" !== destinationType) {
      var message = (label_ ? "destination_type" + ": " + label_ : "destination_type") + " should match one of the following values [ station | address | stop | poi | unknown ] but you provided the value " + destinationType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "pzgV0n5Ze47t", message: message}]);
    }
    return messages;
  }
  
  function assertItemVariant(itemVariant, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("qAitKhHMy0", label_ ? "item_variant" + ": " + label_ : "item_variant", itemVariant));
    return messages;
  }
  
  function assertOptionalItemVariant(itemVariant, label_) {
    var messages = [];
    if (itemVariant !== undefined && itemVariant !== null) {
      messages = messages.concat(AvoAssert.assertString("qAitKhHMy0", label_ ? "item_variant" + ": " + label_ : "item_variant", itemVariant));
    }
    return messages;
  }
  
  function assertOptionalItemListId(itemListId, label_) {
    var messages = [];
    if (itemListId !== undefined && itemListId !== null) {
      messages = messages.concat(AvoAssert.assertString("qAs6FFElba8q", label_ ? "item_list_id" + ": " + label_ : "item_list_id", itemListId));
      if ("plp_kaartjes" !== itemListId &&
          "nsbc_bca" !== itemListId) {
        var message = (label_ ? "item_list_id" + ": " + label_ : "item_list_id") + " should match one of the following values [ plp_kaartjes | nsbc_bca ] but you provided the value " + itemListId
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "qAs6FFElba8q", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalSalesChannel(salesChannel, label_) {
    var messages = [];
    if (salesChannel !== undefined && salesChannel !== null) {
      messages = messages.concat(AvoAssert.assertString("qJKae_S4y_", label_ ? "sales_channel" + ": " + label_ : "sales_channel", salesChannel));
    }
    return messages;
  }
  
  function assertFormId1(formId1, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("s4UF8TMcgsg9", label_ ? "form_id" + ": " + label_ : "form_id", formId1));
    return messages;
  }
  
  function assertOptionalFeedbackRating(feedbackRating, label_) {
    var messages = [];
    if (feedbackRating !== undefined && feedbackRating !== null) {
      messages = messages.concat(AvoAssert.assertString("sctfOrm9GDA0", label_ ? "feedback_rating" + ": " + label_ : "feedback_rating", feedbackRating));
    }
    return messages;
  }
  
  function assertErrorStatus(errorStatus, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("shuP1-uKm", label_ ? "error_status" + ": " + label_ : "error_status", errorStatus));
    return messages;
  }
  
  function assertVideoDuration(videoDuration, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("tFHwzcV_y9J4", label_ ? "video_duration" + ": " + label_ : "video_duration", videoDuration));
    return messages;
  }
  
  function assertOptionalDestinationPath(destinationPath, label_) {
    var messages = [];
    if (destinationPath !== undefined && destinationPath !== null) {
      messages = messages.concat(AvoAssert.assertString("twaKzqqM-SP3", label_ ? "destination_path" + ": " + label_ : "destination_path", destinationPath));
    }
    return messages;
  }
  
  function assertNsEnvironment(nsEnvironment, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ux8kucXh9-", label_ ? "ns_environment" + ": " + label_ : "ns_environment", nsEnvironment));
    if ("acc" !== nsEnvironment &&
        "test" !== nsEnvironment &&
        "prod" !== nsEnvironment &&
        "test2" !== nsEnvironment &&
        "test3" !== nsEnvironment &&
        "testaut" !== nsEnvironment &&
        "testaut2" !== nsEnvironment &&
        "testaut3" !== nsEnvironment &&
        "dev-localhost" !== nsEnvironment &&
        "unittest" !== nsEnvironment) {
      var message = (label_ ? "ns_environment" + ": " + label_ : "ns_environment") + " should match one of the following values [ acc | test | prod | test2 | test3 | testaut | testaut2 | testaut3 | dev-localhost | unittest ] but you provided the value " + nsEnvironment
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ux8kucXh9-", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalWebsiteSection(websiteSection, label_) {
    var messages = [];
    if (websiteSection !== undefined && websiteSection !== null) {
      messages = messages.concat(AvoAssert.assertString("wskyjid5yxT0", label_ ? "website_section" + ": " + label_ : "website_section", websiteSection));
    }
    return messages;
  }
  
  function assertOptionHasTravelassistance(optionHasTravelassistance, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("xp4K_4mDFr_k", label_ ? "option_has_travelassistance" + ": " + label_ : "option_has_travelassistance", optionHasTravelassistance));
    return messages;
  }
  
  function assertMethod(method, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zL_iONcMP8KH", label_ ? "method" + ": " + label_ : "method", method));
    if ("facebook" !== method &&
        "twitter" !== method &&
        "instagram" !== method &&
        "youtube" !== method &&
        "linkedin" !== method) {
      var message = (label_ ? "method" + ": " + label_ : "method") + " should match one of the following values [ facebook | twitter | instagram | youtube | linkedin ] but you provided the value " + method
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "zL_iONcMP8KH", message: message}]);
    }
    return messages;
  }
  
  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }
  
  var sysPlatform;
  var sysLanguage;
  var sysNsEnvironment;
  var sysDatalayerSource;
  var sysPreview;
  
  function setSystemProperties(properties) {
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.language !== null && properties.language !== undefined) {
      sysLanguage = properties.language;
      assertLanguage(sysLanguage);
    }
    if (properties.nsEnvironment !== null && properties.nsEnvironment !== undefined) {
      sysNsEnvironment = properties.nsEnvironment;
      assertNsEnvironment(sysNsEnvironment);
    }
    if (properties.datalayerSource !== null && properties.datalayerSource !== undefined) {
      sysDatalayerSource = properties.datalayerSource;
      assertDatalayerSource(sysDatalayerSource);
    }
    if (properties.preview !== null && properties.preview !== undefined) {
      sysPreview = properties.preview;
      assertOptionalPreview(sysPreview);
    }
  }
  
  function setSystemProperties_(properties) {
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.language !== null && properties.language !== undefined) {
      sysLanguage = properties.language;
      assertLanguage(sysLanguage);
    }
    if (properties.nsEnvironment !== null && properties.nsEnvironment !== undefined) {
      sysNsEnvironment = properties.nsEnvironment;
      assertNsEnvironment(sysNsEnvironment);
    }
    if (properties.datalayerSource !== null && properties.datalayerSource !== undefined) {
      sysDatalayerSource = properties.datalayerSource;
      assertDatalayerSource(sysDatalayerSource);
    }
    if (properties.preview !== null && properties.preview !== undefined) {
      sysPreview = properties.preview;
      assertOptionalPreview(sysPreview);
    }
  }
  
  
  var NsDataQueue;
  function setup_(options, systemProperties, NsDataQueueDestination, destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }
    
    setSystemProperties_(systemProperties);
    
    destinationOptions = destinationOptions || {};
    
    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
      } else {
      }
      
      NsDataQueue = NsDataQueueDestination;
      NsDataQueue.make(options.useProductionKey);
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
      }
    }
  }
  
  function initAvo(options, systemProperties, destinationOptions, NsDataQueueDestination) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
      InternalAvoLogger.warn("****************************************************");
      InternalAvoLogger.warn("WARNING Avo cannot be initialized in noop mode in production:");
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn("- Please reach out if you want to be able to run Avo in production mode with noop=true");
      InternalAvoLogger.warn("****************************************************");
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log("****************************************************");
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log("****************************************************");
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }
    
    setSystemProperties(systemProperties);
    
    destinationOptions = destinationOptions || {};
    
    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
        } =
        WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          "position",
          position => {
            return position === BOTTOM_RIGHT ||
            position === BOTTOM_LEFT ||
            position === TOP_RIGHT ||
            position === TOP_LEFT;
          }
        )
      } catch (e) {
        throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default: throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      _avo_debugger_send_position(positionParams);
    }

(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
      
    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === 'prod') {
      }
      if (__AVO_ENV__ === 'dev') {
      }
      
      NsDataQueue = NsDataQueueDestination;
      if (__AVO_ENV__ === 'prod') {
        NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
      } else if (__AVO_ENV__ === 'dev') {
        NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
      } else {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for nsDataQueue. Head to destination settings in Avo to set a staging key.");
        NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
      }
    }
  }
  
  /**
   * registration_start: Event sent when a user clicks the signup button and that way starts the signup process.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/CpCZNX24H8}
   */
  function registrationStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("registration_start", Object.keys(properties), [
        "mijnnsVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CpCZNX24H8", "98ad0b7902bd0f2eaf2ebddb9a07c8a2de159496b2613f207f08407b9aed673a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("registration_start", {
        "schema": "iglu:nl.ns/registration_start/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CpCZNX24H8", "registration_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/registration_start/jsonschema/1-0-0"},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'registration_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_start", {
          "schema": "iglu:nl.ns/registration_start/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "CpCZNX24H8", "98ad0b7902bd0f2eaf2ebddb9a07c8a2de159496b2613f207f08407b9aed673a");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("registration_start", {
      "schema": "iglu:nl.ns/registration_start/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * registration_success: Event sent when a user clicks the submit button and ends the signup process.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * @param {string} [properties.customerEntity] - Type entiteit van het record
   * @param {string} properties.hashedEmail - SHA256 hash of email address
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/aan9iGJR9q}
   */
  function registrationSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertOptionalCustomerEntity(properties.customerEntity));
      messages = messages.concat(assertHashedEmail(properties.hashedEmail));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("registration_success", Object.keys(properties), [
        "userId_",
        "mijnnsVersion",
        "customerEntity",
        "hashedEmail"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aan9iGJR9q", "9f653d4bdd3f81b2a584ada1c2a867b98355f8ff5157da602174d7496a8ecd42", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("registration_success", {
        "schema": "iglu:nl.ns/registration_success/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "customer_entity": properties.customerEntity,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {
        "hashed_email": properties.hashedEmail,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aan9iGJR9q", "registration_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/registration_success/jsonschema/1-0-0"},
        {id: "TQleINBSI93G", name: "customer_entity", value: properties.customerEntity},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [
        {id:"ALoQI7FpkV", name: "hashed_email", value: properties.hashedEmail},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'registration_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_success", {
          "schema": "iglu:nl.ns/registration_success/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "customer_entity": properties.customerEntity,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "aan9iGJR9q", "9f653d4bdd3f81b2a584ada1c2a867b98355f8ff5157da602174d7496a8ecd42");
      }
      // destination NsDataQueue
      NsDataQueue.setUserProperties(properties.userId_, {
      "hashed_email": properties.hashedEmail,
      });
      NsDataQueue.logEvent("registration_success", {
      "schema": "iglu:nl.ns/registration_success/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "customer_entity": properties.customerEntity,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * login_start: Event sent a when a user clicks the log in button and begins the login process.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/9IX1dJEetN}
   */
  function loginStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("login_start", Object.keys(properties), [
        "mijnnsVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9IX1dJEetN", "79cc5a1fc82bde0a6a2483850376289ff7b75c40a38d5c99bb445874a7070f77", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("login_start", {
        "schema": "iglu:nl.ns/login_start/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9IX1dJEetN", "login_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/login_start/jsonschema/1-0-0"},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'login_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("login_start", {
          "schema": "iglu:nl.ns/login_start/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "9IX1dJEetN", "79cc5a1fc82bde0a6a2483850376289ff7b75c40a38d5c99bb445874a7070f77");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("login_start", {
      "schema": "iglu:nl.ns/login_start/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * login_error: Event sent when a user's account information is not successfully authenticated.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * @param {string} properties.error - Error message that was displayed
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/eGcvTR899Z}
   */
  function loginError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertError(properties.error));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("login_error", Object.keys(properties), [
        "mijnnsVersion",
        "error"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eGcvTR899Z", "ba68bd8700522e7e4cfcbc9f7c1c4e591c9785fcf9ef916a803e845084c708f2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("login_error", {
        "schema": "iglu:nl.ns/login_error/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "error": properties.error,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eGcvTR899Z", "login_error", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/login_error/jsonschema/1-0-0"},
        {id: "Oi6yaZll3yFM", name: "error", value: properties.error},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'login_error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("login_error", {
          "schema": "iglu:nl.ns/login_error/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "error": properties.error,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "eGcvTR899Z", "ba68bd8700522e7e4cfcbc9f7c1c4e591c9785fcf9ef916a803e845084c708f2");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("login_error", {
      "schema": "iglu:nl.ns/login_error/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "error": properties.error,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * session_start: Event fires at the first page view in a user session [definitie gebruikerssessie].
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.utmSource] - Source of the campaign
   * @param {string} [properties.utmMedium] - Medium of marketing campaign (CPC etc)
   * @param {string} [properties.utmCampaign] - name of the marketing campaign responsible for this visit
   * @param {string} [properties.utmTerm] - term used in search or custom utm param
   * @param {string} [properties.utmContent] - description of campaign content
   * @param {string} [properties.utmId] - utm id
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/Fa-EbJyylC8}
   */
  function sessionStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalUtmSource(properties.utmSource));
      messages = messages.concat(assertOptionalUtmMedium(properties.utmMedium));
      messages = messages.concat(assertOptionalUtmCampaign(properties.utmCampaign));
      messages = messages.concat(assertOptionalUtmTerm(properties.utmTerm));
      messages = messages.concat(assertOptionalUtmContent(properties.utmContent));
      messages = messages.concat(assertOptionalUtmId(properties.utmId));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("session_start", Object.keys(properties), [
        "utmSource",
        "utmMedium",
        "utmCampaign",
        "utmTerm",
        "utmContent",
        "utmId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Fa-EbJyylC8", "10364ba27983b797c2fd392d156bd64c59bf5dc469719fcf15d93d837eb25130", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("session_start", {
        "schema": "iglu:nl.ns/session_start/jsonschema/1-0-0",
        "utm_source": properties.utmSource,
        "utm_medium": properties.utmMedium,
        "utm_campaign": properties.utmCampaign,
        "utm_term": properties.utmTerm,
        "utm_content": properties.utmContent,
        "utm_id": properties.utmId,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Fa-EbJyylC8", "session_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/session_start/jsonschema/1-0-0"},
        {id: "3k9em70_j0Ac", name: "utm_campaign", value: properties.utmCampaign},
        {id: "4X73rTMNgTkZ", name: "utm_source", value: properties.utmSource},
        {id: "BXSsSA9Tphqq", name: "utm_id", value: properties.utmId},
        {id: "TigsIVrjd8Ws", name: "utm_term", value: properties.utmTerm},
        {id: "WCgPbfCy_8b3", name: "utm_medium", value: properties.utmMedium},
        {id: "jksVIoRXIWk2", name: "utm_content", value: properties.utmContent},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'session_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("session_start", {
          "schema": "iglu:nl.ns/session_start/jsonschema/1-0-0",
          "utm_source": properties.utmSource,
          "utm_medium": properties.utmMedium,
          "utm_campaign": properties.utmCampaign,
          "utm_term": properties.utmTerm,
          "utm_content": properties.utmContent,
          "utm_id": properties.utmId,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "Fa-EbJyylC8", "10364ba27983b797c2fd392d156bd64c59bf5dc469719fcf15d93d837eb25130");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("session_start", {
      "schema": "iglu:nl.ns/session_start/jsonschema/1-0-0",
      "utm_source": properties.utmSource,
      "utm_medium": properties.utmMedium,
      "utm_campaign": properties.utmCampaign,
      "utm_term": properties.utmTerm,
      "utm_content": properties.utmContent,
      "utm_id": properties.utmId,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * scroll: Triggers when a certain % of the page depth has been reached
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.percent - Scroll depth on the page that has been reached.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/jY9kOhOVXBX}
   */
  function scroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPercent(properties.percent));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("scroll", Object.keys(properties), [
        "percent"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jY9kOhOVXBX", "34676bb35754dc582f7a65f0533787bd262d89f05a1c895cf75e97074e3ae187", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("scroll", {
        "schema": "iglu:nl.ns/scroll/jsonschema/1-0-0",
        "percent": properties.percent,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jY9kOhOVXBX", "scroll", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/scroll/jsonschema/1-0-0"},
        {id: "_iIBN-4DdOc1", name: "percent", value: properties.percent},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("scroll", {
          "schema": "iglu:nl.ns/scroll/jsonschema/1-0-0",
          "percent": properties.percent,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "jY9kOhOVXBX", "34676bb35754dc582f7a65f0533787bd262d89f05a1c895cf75e97074e3ae187");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("scroll", {
      "schema": "iglu:nl.ns/scroll/jsonschema/1-0-0",
      "percent": properties.percent,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * visit_qualified: 30s on page or clickthrough
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mo12laQ7-DZ}
   */
  function visitQualified(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("visit_qualified", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mo12laQ7-DZ", "035ef339a50989333ce5f15cb0b1545344aa87a8f713aa5d20d9737653d8c9d7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("visit_qualified", {
        "schema": "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mo12laQ7-DZ", "visit_qualified", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/visit_qualified/jsonschema/1-0-0"},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'visit_qualified': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("visit_qualified", {
          "schema": "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "mo12laQ7-DZ", "035ef339a50989333ce5f15cb0b1545344aa87a8f713aa5d20d9737653d8c9d7");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("visit_qualified", {
      "schema": "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * begin_checkout: triggers when you hit add to cart button, go to cart  etc. next step after product detail page
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {string} properties.coupon - coupon-code or campaign id
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/YSfuMbF3uzA}
   */
  function beginCheckout(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertCoupon(properties.coupon));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("begin_checkout", Object.keys(properties), [
        "currency",
        "coupon",
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YSfuMbF3uzA", "29cf123899dbc7662c99803e93b3788293a53242c18b0e837d1055f1cf603416", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("begin_checkout", {
        "schema": "iglu:nl.ns/begin_checkout/jsonschema/1-0-2",
        "currency": properties.currency,
        "coupon": properties.coupon,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YSfuMbF3uzA", "begin_checkout", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/begin_checkout/jsonschema/1-0-2"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'begin_checkout': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("begin_checkout", {
          "schema": "iglu:nl.ns/begin_checkout/jsonschema/1-0-2",
          "currency": properties.currency,
          "coupon": properties.coupon,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "YSfuMbF3uzA", "29cf123899dbc7662c99803e93b3788293a53242c18b0e837d1055f1cf603416");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("begin_checkout", {
      "schema": "iglu:nl.ns/begin_checkout/jsonschema/1-0-2",
      "currency": properties.currency,
      "coupon": properties.coupon,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * purchase: triggered when a purchase is verified (payed etc.) pref. server side, not dependend on a 'succes page' view.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {string} properties.transactionId - Transaction or Order ID of the order
   * @param {string} [properties.coupon] - coupon-code or campaign id
   * @param {float} [properties.tax] - € value of tax
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {Array<string>} [properties.paymentType] - payment type like iDeal, Creditcard etc
   * @param {string} [properties.ticketClass] - class: first or second
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/AVPCdJ0ONj2}
   */
  function purchase(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertTransactionId(properties.transactionId));
      messages = messages.concat(assertOptionalCoupon(properties.coupon));
      messages = messages.concat(assertOptionalTax(properties.tax));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalPaymentType(properties.paymentType));
      messages = messages.concat(assertOptionalTicketClass(properties.ticketClass));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("purchase", Object.keys(properties), [
        "currency",
        "transactionId",
        "coupon",
        "tax",
        "value",
        "items",
        "nsShop",
        "paymentType",
        "ticketClass",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AVPCdJ0ONj2", "a3fe344079e736f08971adb0159d93a9f658498b34d78e597f288846cac545c5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("purchase", {
        "schema": "iglu:nl.ns/purchase/jsonschema/2-0-7",
        "currency": properties.currency,
        "transaction_id": properties.transactionId,
        "coupon": properties.coupon,
        "tax": properties.tax,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "payment_type": properties.paymentType,
        "ticket_class": properties.ticketClass,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AVPCdJ0ONj2", "purchase", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/purchase/jsonschema/2-0-7"},
        {id: "06ak1UmwgYlK", name: "payment_type", value: properties.paymentType},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "IBS3IO629xIC", name: "tax", value: properties.tax},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "SCki6fM2wea", name: "transaction_id", value: properties.transactionId},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'purchase': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("purchase", {
          "schema": "iglu:nl.ns/purchase/jsonschema/2-0-7",
          "currency": properties.currency,
          "transaction_id": properties.transactionId,
          "coupon": properties.coupon,
          "tax": properties.tax,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "payment_type": properties.paymentType,
          "ticket_class": properties.ticketClass,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "AVPCdJ0ONj2", "a3fe344079e736f08971adb0159d93a9f658498b34d78e597f288846cac545c5");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("purchase", {
      "schema": "iglu:nl.ns/purchase/jsonschema/2-0-7",
      "currency": properties.currency,
      "transaction_id": properties.transactionId,
      "coupon": properties.coupon,
      "tax": properties.tax,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "payment_type": properties.paymentType,
      "ticket_class": properties.ticketClass,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * click: click on links buttons etc
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickClasses - no description
   * @param {string} properties.clickType - e.g. 'button', 'checkbox', 'text_link'
   * @param {string} properties.clickDestination - Provide URL if the button navigates
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} [properties.data] - Extra information in string format
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} [properties.clickId1] - The HTML id attribute for an outbound link or file download
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/1s4XEWLbFQ9}
   */
  function click(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickClasses(properties.clickClasses));
      messages = messages.concat(assertClickType(properties.clickType));
      messages = messages.concat(assertClickDestination(properties.clickDestination));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalData(properties.data));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertOptionalClickId1(properties.clickId1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("click", Object.keys(properties), [
        "clickClasses",
        "clickType",
        "clickDestination",
        "clickText",
        "data",
        "websiteSection",
        "clickId1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1s4XEWLbFQ9", "172e127a3999d035764de7400230baacadb6fd6ed45b4707754f5d6e50e79fae", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("click", {
        "schema": "iglu:nl.ns/click/jsonschema/1-0-2",
        "click_classes": properties.clickClasses,
        "click_type": properties.clickType,
        "click_destination": properties.clickDestination,
        "click_text": properties.clickText,
        "data": properties.data,
        "website_section": properties.websiteSection,
        "click_id": properties.clickId1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1s4XEWLbFQ9", "click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/click/jsonschema/1-0-2"},
        {id: "7HGUvDZb-Fax", name: "data", value: properties.data},
        {id: "BxxFgWL7KfAD", name: "click_type", value: properties.clickType},
        {id: "HolZTTkkioUB", name: "click_id", value: properties.clickId1},
        {id: "K5J4L8efdGgl", name: "click_classes", value: properties.clickClasses},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click", {
          "schema": "iglu:nl.ns/click/jsonschema/1-0-2",
          "click_classes": properties.clickClasses,
          "click_type": properties.clickType,
          "click_destination": properties.clickDestination,
          "click_text": properties.clickText,
          "data": properties.data,
          "website_section": properties.websiteSection,
          "click_id": properties.clickId1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "1s4XEWLbFQ9", "172e127a3999d035764de7400230baacadb6fd6ed45b4707754f5d6e50e79fae");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("click", {
      "schema": "iglu:nl.ns/click/jsonschema/1-0-2",
      "click_classes": properties.clickClasses,
      "click_type": properties.clickType,
      "click_destination": properties.clickDestination,
      "click_text": properties.clickText,
      "data": properties.data,
      "website_section": properties.websiteSection,
      "click_id": properties.clickId1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * feedback_give: triggers on submition of feedback
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.feedbackPlatform - Platform that is used to gather feedback
   * @param {string} [properties.feedbackRating] - Rating that was given
   * @param {string} [properties.feedbackType] - Type of feedback. i.e. 'responsive-dialog' or 'feedback-button'
   * @param {string} [properties.feedbackName] - Name of the survey or feedback button
   * @param {string} properties.teamName - Name of the team (feedback/qualtrics)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/QFK9qm6fM6V}
   */
  function feedbackGive(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFeedbackPlatform(properties.feedbackPlatform));
      messages = messages.concat(assertOptionalFeedbackRating(properties.feedbackRating));
      messages = messages.concat(assertOptionalFeedbackType(properties.feedbackType));
      messages = messages.concat(assertOptionalFeedbackName(properties.feedbackName));
      messages = messages.concat(assertTeamName(properties.teamName));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("feedback_give", Object.keys(properties), [
        "feedbackPlatform",
        "feedbackRating",
        "feedbackType",
        "feedbackName",
        "teamName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QFK9qm6fM6V", "9d41610b2a6add76c029d0391db49a761c0733ebb15594c96be02b96bb0b2c25", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("feedback_give", {
        "schema": "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
        "feedback_platform": properties.feedbackPlatform,
        "feedback_rating": properties.feedbackRating,
        "feedback_type": properties.feedbackType,
        "feedback_name": properties.feedbackName,
        "team_name": properties.teamName,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QFK9qm6fM6V", "feedback_give", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/feedback_give/jsonschema/1-0-2"},
        {id: "5EE-BUb_w", name: "feedback_type", value: properties.feedbackType},
        {id: "BRMFCaolHInZ", name: "feedback_platform", value: properties.feedbackPlatform},
        {id: "Xhkk5MHMs", name: "feedback_name", value: properties.feedbackName},
        {id: "XoZ_JHMfu", name: "team_name", value: properties.teamName},
        {id: "sctfOrm9GDA0", name: "feedback_rating", value: properties.feedbackRating},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'feedback_give': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("feedback_give", {
          "schema": "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
          "feedback_platform": properties.feedbackPlatform,
          "feedback_rating": properties.feedbackRating,
          "feedback_type": properties.feedbackType,
          "feedback_name": properties.feedbackName,
          "team_name": properties.teamName,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "QFK9qm6fM6V", "9d41610b2a6add76c029d0391db49a761c0733ebb15594c96be02b96bb0b2c25");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("feedback_give", {
      "schema": "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
      "feedback_platform": properties.feedbackPlatform,
      "feedback_rating": properties.feedbackRating,
      "feedback_type": properties.feedbackType,
      "feedback_name": properties.feedbackName,
      "team_name": properties.teamName,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * content_share: triggers on last onsite/in app action of sharing
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.method - The method in which the content is shared.
   * @param {string} properties.contentType - The type of shared content.
   * @param {string} [properties.itemId] - ID of the product  / unique SKU for product
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/D_FIMLMedlm}
   */
  function contentShare(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMethod(properties.method));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertOptionalItemId(properties.itemId));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("content_share", Object.keys(properties), [
        "method",
        "contentType",
        "itemId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D_FIMLMedlm", "888e3a2e99ed2ddbdfce936ef78a93c8067c0fc5bc8acb5bc8bb63ab0780c7d6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("content_share", {
        "schema": "iglu:nl.ns/content_share/jsonschema/1-0-0",
        "method": properties.method,
        "content_type": properties.contentType,
        "item_id": properties.itemId,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D_FIMLMedlm", "content_share", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/content_share/jsonschema/1-0-0"},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "jbSdZ_YNpuuA", name: "content_type", value: properties.contentType},
        {id: "zL_iONcMP8KH", name: "method", value: properties.method},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'content_share': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("content_share", {
          "schema": "iglu:nl.ns/content_share/jsonschema/1-0-0",
          "method": properties.method,
          "content_type": properties.contentType,
          "item_id": properties.itemId,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "D_FIMLMedlm", "888e3a2e99ed2ddbdfce936ef78a93c8067c0fc5bc8acb5bc8bb63ab0780c7d6");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("content_share", {
      "schema": "iglu:nl.ns/content_share/jsonschema/1-0-0",
      "method": properties.method,
      "content_type": properties.contentType,
      "item_id": properties.itemId,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * form_start: triggers on first click in the form
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formName - Name parameter from the <form> tag
   * @param {string} properties.formId1 - ID parameter of the form tag
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mBzV6jmUM7H}
   */
  function formStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("form_start", Object.keys(properties), [
        "formName",
        "formId1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mBzV6jmUM7H", "cc143569bc9e08720bea92bc1675671a4ff3d68a1d6746ed9300919800a7e4b6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("form_start", {
        "schema": "iglu:nl.ns/form_start/jsonschema/1-0-0",
        "form_name": properties.formName,
        "form_id": properties.formId1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mBzV6jmUM7H", "form_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_start/jsonschema/1-0-0"},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'form_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_start", {
          "schema": "iglu:nl.ns/form_start/jsonschema/1-0-0",
          "form_name": properties.formName,
          "form_id": properties.formId1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "mBzV6jmUM7H", "cc143569bc9e08720bea92bc1675671a4ff3d68a1d6746ed9300919800a7e4b6");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("form_start", {
      "schema": "iglu:nl.ns/form_start/jsonschema/1-0-0",
      "form_name": properties.formName,
      "form_id": properties.formId1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * form_submit: triggers after submitting the form (after field validation)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formId1 - ID parameter of the form tag
   * @param {string} properties.formDestination - Full URL of the redirect after the form submit
   * @param {Array<string>} [properties.permissions] - Array with modified permissions and status
[
  {
    'type':'Commercieel',
    'status':'true',
  },
  {
    'type':'Reisgegevens delen',
    'status':'false',
  },
]
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} properties.formName - Name parameter from the <form> tag
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/DBkD3D8Uq_u}
   */
  function formSubmit(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertFormDestination(properties.formDestination));
      messages = messages.concat(assertOptionalPermissions(properties.permissions));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("form_submit", Object.keys(properties), [
        "formId1",
        "formDestination",
        "permissions",
        "clickText",
        "formName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DBkD3D8Uq_u", "43e550ce3db71ac7184c84668dfcec1c0dbea61267cb779429b9d06f82a44ef3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("form_submit", {
        "schema": "iglu:nl.ns/form_submit/jsonschema/1-0-0",
        "form_id": properties.formId1,
        "form_destination": properties.formDestination,
        "permissions": properties.permissions,
        "click_text": properties.clickText,
        "form_name": properties.formName,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DBkD3D8Uq_u", "form_submit", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_submit/jsonschema/1-0-0"},
        {id: "83KZlBXgHnFi", name: "form_destination", value: properties.formDestination},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "b6ebejYlEx2Y", name: "permissions", value: properties.permissions},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'form_submit': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_submit", {
          "schema": "iglu:nl.ns/form_submit/jsonschema/1-0-0",
          "form_id": properties.formId1,
          "form_destination": properties.formDestination,
          "permissions": properties.permissions,
          "click_text": properties.clickText,
          "form_name": properties.formName,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "DBkD3D8Uq_u", "43e550ce3db71ac7184c84668dfcec1c0dbea61267cb779429b9d06f82a44ef3");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("form_submit", {
      "schema": "iglu:nl.ns/form_submit/jsonschema/1-0-0",
      "form_id": properties.formId1,
      "form_destination": properties.formDestination,
      "permissions": properties.permissions,
      "click_text": properties.clickText,
      "form_name": properties.formName,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * form_error: triggers after field validation
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formName - Name parameter from the <form> tag
   * @param {string} properties.formId1 - ID parameter of the form tag
   * @param {Array<string>} properties.errorMessage - What error message(s) does the user see? List of translation keys or strings.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/xduE82bRW-m}
   */
  function formError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("form_error", Object.keys(properties), [
        "formName",
        "formId1",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xduE82bRW-m", "aa2bd3888cd49d6c17694b56869e07554e742ae504237639527ae06192458005", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("form_error", {
        "schema": "iglu:nl.ns/form_error/jsonschema/1-0-0",
        "form_name": properties.formName,
        "form_id": properties.formId1,
        "error_message": properties.errorMessage,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xduE82bRW-m", "form_error", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_error/jsonschema/1-0-0"},
        {id: "_UC5Zg5bYPN", name: "error_message", value: properties.errorMessage},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'form_error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_error", {
          "schema": "iglu:nl.ns/form_error/jsonschema/1-0-0",
          "form_name": properties.formName,
          "form_id": properties.formId1,
          "error_message": properties.errorMessage,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "xduE82bRW-m", "aa2bd3888cd49d6c17694b56869e07554e742ae504237639527ae06192458005");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("form_error", {
      "schema": "iglu:nl.ns/form_error/jsonschema/1-0-0",
      "form_name": properties.formName,
      "form_id": properties.formId1,
      "error_message": properties.errorMessage,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * view_item: Triggers when the product detail page is viewed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/jwnzAKOyDYr}
   */
  function viewItem(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("view_item", Object.keys(properties), [
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jwnzAKOyDYr", "22c4e614fc1037b0f7151af2529879dc204c4962a0c8127e835e09059d10f054", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("view_item", {
        "currency": "EUR",
        "schema": "iglu:nl.ns/view_item/jsonschema/1-0-2",
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jwnzAKOyDYr", "view_item", messages, [
        {id: "GuYrcDncVS5", name: "currency", value: "EUR"},
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/view_item/jsonschema/1-0-2"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'view_item': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item", {
          "currency": "EUR",
          "schema": "iglu:nl.ns/view_item/jsonschema/1-0-2",
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "jwnzAKOyDYr", "22c4e614fc1037b0f7151af2529879dc204c4962a0c8127e835e09059d10f054");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("view_item", {
      "currency": "EUR",
      "schema": "iglu:nl.ns/view_item/jsonschema/1-0-2",
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * keuzehulp_click: Triggers when a user clicks on a given choice in the keuzehulp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.question - question
   * @param {string} properties.answer - answer
   * @param {string} properties.websiteVersion - Consument of zakelijk
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/zxrhsEtLq6G}
   */
  function keuzehulpClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuestion(properties.question));
      messages = messages.concat(assertAnswer(properties.answer));
      messages = messages.concat(assertWebsiteVersion(properties.websiteVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("keuzehulp_click", Object.keys(properties), [
        "question",
        "answer",
        "websiteVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zxrhsEtLq6G", "f0a4b60054367f2f3d62ad79f53bddc97fbd72b1ade5b97f9e5999011056e0ad", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("keuzehulp_click", {
        "schema": "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
        "question": properties.question,
        "answer": properties.answer,
        "website_version": properties.websiteVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zxrhsEtLq6G", "keuzehulp_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0"},
        {id: "7f5ty_nULaWo", name: "question", value: properties.question},
        {id: "F4RDcFwudL0_", name: "answer", value: properties.answer},
        {id: "l4YWQepFGqt9", name: "website_version", value: properties.websiteVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'keuzehulp_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("keuzehulp_click", {
          "schema": "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
          "question": properties.question,
          "answer": properties.answer,
          "website_version": properties.websiteVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "zxrhsEtLq6G", "f0a4b60054367f2f3d62ad79f53bddc97fbd72b1ade5b97f9e5999011056e0ad");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("keuzehulp_click", {
      "schema": "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
      "question": properties.question,
      "answer": properties.answer,
      "website_version": properties.websiteVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * keuzehulp_success: Triggers on show page advice keuzehulp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.websiteVersion - Consument of zakelijk
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/oxnl9fXxacs}
   */
  function keuzehulpSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertWebsiteVersion(properties.websiteVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("keuzehulp_success", Object.keys(properties), [
        "items",
        "websiteVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oxnl9fXxacs", "7f73886e556346f152a2a80e243dad754afa41fa64f674f4cccc0595b2cb70cf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("keuzehulp_success", {
        "schema": "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0",
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "website_version": properties.websiteVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oxnl9fXxacs", "keuzehulp_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "l4YWQepFGqt9", name: "website_version", value: properties.websiteVersion},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'keuzehulp_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("keuzehulp_success", {
          "schema": "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0",
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "website_version": properties.websiteVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "oxnl9fXxacs", "7f73886e556346f152a2a80e243dad754afa41fa64f674f4cccc0595b2cb70cf");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("keuzehulp_success", {
      "schema": "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0",
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "website_version": properties.websiteVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * chat_start: Triggers on opening the chat widget
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.chatTool - Name of the Chat Module/Chat Agent i.e. 'Cognigy'; 'EnterpriseBot', 'Parley'
   * @param {string} properties.chatInitiator - How was the chat started? Opened by click, hover, time-based, 
   * @param {string} [properties.chatClickSource] - What was the source of the chat_initiator, liveChat, 
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/whazzFBzCgx}
   */
  function chatStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertChatTool(properties.chatTool));
      messages = messages.concat(assertChatInitiator(properties.chatInitiator));
      messages = messages.concat(assertOptionalChatClickSource(properties.chatClickSource));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("chat_start", Object.keys(properties), [
        "chatTool",
        "chatInitiator",
        "chatClickSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "whazzFBzCgx", "e22f46c7765145fc0e3f6d338957b8360e52da7ffe479a13298ac0a03c82b963", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("chat_start", {
        "schema": "iglu:nl.ns/chat_start/jsonschema/1-0-0",
        "chat_tool": properties.chatTool,
        "chat_initiator": properties.chatInitiator,
        "chat_click_source": properties.chatClickSource,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("whazzFBzCgx", "chat_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/chat_start/jsonschema/1-0-0"},
        {id: "5pRtByAXn", name: "chat_initiator", value: properties.chatInitiator},
        {id: "B7jES2_im", name: "chat_tool", value: properties.chatTool},
        {id: "j8qPJcH-G", name: "chat_click_source", value: properties.chatClickSource},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'chat_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("chat_start", {
          "schema": "iglu:nl.ns/chat_start/jsonschema/1-0-0",
          "chat_tool": properties.chatTool,
          "chat_initiator": properties.chatInitiator,
          "chat_click_source": properties.chatClickSource,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "whazzFBzCgx", "e22f46c7765145fc0e3f6d338957b8360e52da7ffe479a13298ac0a03c82b963");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("chat_start", {
      "schema": "iglu:nl.ns/chat_start/jsonschema/1-0-0",
      "chat_tool": properties.chatTool,
      "chat_initiator": properties.chatInitiator,
      "chat_click_source": properties.chatClickSource,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * video_start: when the video starts playing
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.videoTitle - title of the video
   * @param {string} properties.videoUrl - link of the video
   * @param {bool} properties.visible - true if the video is in the viewport
   * @param {string} properties.videoProvider1 - youtube, vimeo, brightcove, etc
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/-UuwVQnJInf}
   */
  function videoStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertVideoTitle(properties.videoTitle));
      messages = messages.concat(assertVideoUrl(properties.videoUrl));
      messages = messages.concat(assertVisible(properties.visible));
      messages = messages.concat(assertVideoProvider1(properties.videoProvider1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("video_start", Object.keys(properties), [
        "videoTitle",
        "videoUrl",
        "visible",
        "videoProvider1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-UuwVQnJInf", "64939fd8e25634e2e3be12e3832547e45913a83a44efd7f5a1fd1e6ab73a46dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("video_start", {
        "schema": "iglu:nl.ns/video_start/jsonschema/1-0-0",
        "video_title": properties.videoTitle,
        "video_url": properties.videoUrl,
        "visible": properties.visible,
        "video_provider": properties.videoProvider1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-UuwVQnJInf", "video_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/video_start/jsonschema/1-0-0"},
        {id: "2b5JV7Hc-MhF", name: "visible", value: properties.visible},
        {id: "5W6xoSKVWDn2", name: "video_url", value: properties.videoUrl},
        {id: "E29-6P-mJPC9", name: "video_title", value: properties.videoTitle},
        {id: "Hx_El_YtO-Wk", name: "video_provider", value: properties.videoProvider1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'video_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("video_start", {
          "schema": "iglu:nl.ns/video_start/jsonschema/1-0-0",
          "video_title": properties.videoTitle,
          "video_url": properties.videoUrl,
          "visible": properties.visible,
          "video_provider": properties.videoProvider1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "-UuwVQnJInf", "64939fd8e25634e2e3be12e3832547e45913a83a44efd7f5a1fd1e6ab73a46dd");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("video_start", {
      "schema": "iglu:nl.ns/video_start/jsonschema/1-0-0",
      "video_title": properties.videoTitle,
      "video_url": properties.videoUrl,
      "visible": properties.visible,
      "video_provider": properties.videoProvider1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * video_progress: when the video progresses past 10%, 25%, 50%, and 75% duration time
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.videoTitle - title of the video
   * @param {string} properties.videoUrl - link of the video
   * @param {float} properties.videoCurrentTime - no description
   * @param {float} properties.videoDuration - no description
   * @param {int} properties.videoPercent - % watch of total video length
   * @param {bool} properties.visible - true if the video is in the viewport
   * @param {string} properties.videoProvider1 - youtube, vimeo, brightcove, etc
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/frCti8DVUp5}
   */
  function videoProgress(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertVideoTitle(properties.videoTitle));
      messages = messages.concat(assertVideoUrl(properties.videoUrl));
      messages = messages.concat(assertVideoCurrentTime(properties.videoCurrentTime));
      messages = messages.concat(assertVideoDuration(properties.videoDuration));
      messages = messages.concat(assertVideoPercent(properties.videoPercent));
      messages = messages.concat(assertVisible(properties.visible));
      messages = messages.concat(assertVideoProvider1(properties.videoProvider1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("video_progress", Object.keys(properties), [
        "videoTitle",
        "videoUrl",
        "videoCurrentTime",
        "videoDuration",
        "videoPercent",
        "visible",
        "videoProvider1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "frCti8DVUp5", "32ae743a265b655dec95a77e0f8f782d9d66ac835f9348c09592864a4018101d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("video_progress", {
        "schema": "iglu:nl.ns/video_progress/jsonschema/1-0-0",
        "video_title": properties.videoTitle,
        "video_url": properties.videoUrl,
        "video_current_time": properties.videoCurrentTime,
        "video_duration": properties.videoDuration,
        "video_percent": properties.videoPercent,
        "visible": properties.visible,
        "video_provider": properties.videoProvider1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("frCti8DVUp5", "video_progress", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/video_progress/jsonschema/1-0-0"},
        {id: "2b5JV7Hc-MhF", name: "visible", value: properties.visible},
        {id: "5W6xoSKVWDn2", name: "video_url", value: properties.videoUrl},
        {id: "C3vfalxpU8Ib", name: "video_current_time", value: properties.videoCurrentTime},
        {id: "E29-6P-mJPC9", name: "video_title", value: properties.videoTitle},
        {id: "Hx_El_YtO-Wk", name: "video_provider", value: properties.videoProvider1},
        {id: "KtXvxPrGGhXA", name: "video_percent", value: properties.videoPercent},
        {id: "tFHwzcV_y9J4", name: "video_duration", value: properties.videoDuration},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'video_progress': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("video_progress", {
          "schema": "iglu:nl.ns/video_progress/jsonschema/1-0-0",
          "video_title": properties.videoTitle,
          "video_url": properties.videoUrl,
          "video_current_time": properties.videoCurrentTime,
          "video_duration": properties.videoDuration,
          "video_percent": properties.videoPercent,
          "visible": properties.visible,
          "video_provider": properties.videoProvider1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "frCti8DVUp5", "32ae743a265b655dec95a77e0f8f782d9d66ac835f9348c09592864a4018101d");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("video_progress", {
      "schema": "iglu:nl.ns/video_progress/jsonschema/1-0-0",
      "video_title": properties.videoTitle,
      "video_url": properties.videoUrl,
      "video_current_time": properties.videoCurrentTime,
      "video_duration": properties.videoDuration,
      "video_percent": properties.videoPercent,
      "visible": properties.visible,
      "video_provider": properties.videoProvider1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * video_complete: when the video ends (100% viewed)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.videoTitle - title of the video
   * @param {string} properties.videoUrl - link of the video
   * @param {float} properties.videoCurrentTime - no description
   * @param {string} properties.videoProvider1 - youtube, vimeo, brightcove, etc
   * @param {bool} properties.visible - true if the video is in the viewport
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/A9DN33XJgfq}
   */
  function videoComplete(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertVideoTitle(properties.videoTitle));
      messages = messages.concat(assertVideoUrl(properties.videoUrl));
      messages = messages.concat(assertVideoCurrentTime(properties.videoCurrentTime));
      messages = messages.concat(assertVideoProvider1(properties.videoProvider1));
      messages = messages.concat(assertVisible(properties.visible));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("video_complete", Object.keys(properties), [
        "videoTitle",
        "videoUrl",
        "videoCurrentTime",
        "videoProvider1",
        "visible"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "A9DN33XJgfq", "71c4fdbec4a97846981545919b84e6e0f17198d47e3f65972f3d60dfb161d7b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("video_complete", {
        "schema": "iglu:nl.ns/video_complete/jsonschema/1-0-0",
        "video_title": properties.videoTitle,
        "video_url": properties.videoUrl,
        "video_current_time": properties.videoCurrentTime,
        "video_provider": properties.videoProvider1,
        "visible": properties.visible,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("A9DN33XJgfq", "video_complete", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/video_complete/jsonschema/1-0-0"},
        {id: "2b5JV7Hc-MhF", name: "visible", value: properties.visible},
        {id: "5W6xoSKVWDn2", name: "video_url", value: properties.videoUrl},
        {id: "C3vfalxpU8Ib", name: "video_current_time", value: properties.videoCurrentTime},
        {id: "E29-6P-mJPC9", name: "video_title", value: properties.videoTitle},
        {id: "Hx_El_YtO-Wk", name: "video_provider", value: properties.videoProvider1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'video_complete': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("video_complete", {
          "schema": "iglu:nl.ns/video_complete/jsonschema/1-0-0",
          "video_title": properties.videoTitle,
          "video_url": properties.videoUrl,
          "video_current_time": properties.videoCurrentTime,
          "video_provider": properties.videoProvider1,
          "visible": properties.visible,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "A9DN33XJgfq", "71c4fdbec4a97846981545919b84e6e0f17198d47e3f65972f3d60dfb161d7b3");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("video_complete", {
      "schema": "iglu:nl.ns/video_complete/jsonschema/1-0-0",
      "video_title": properties.videoTitle,
      "video_url": properties.videoUrl,
      "video_current_time": properties.videoCurrentTime,
      "video_provider": properties.videoProvider1,
      "visible": properties.visible,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * lead_generate: when succesfull leadform send by user
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formId1 - ID parameter of the form tag
   * @param {string} properties.formName - Name parameter from the <form> tag
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/ubmAH73Pvjx}
   */
  function leadGenerate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("lead_generate", Object.keys(properties), [
        "formId1",
        "formName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ubmAH73Pvjx", "01337c1c25b4f3348ab882b1ca7d12a3c49560f93c27e583b08b01021c911dd1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("lead_generate", {
        "schema": "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
        "form_id": properties.formId1,
        "form_name": properties.formName,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ubmAH73Pvjx", "lead_generate", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/lead_generate/jsonschema/1-0-0"},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'lead_generate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lead_generate", {
          "schema": "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
          "form_id": properties.formId1,
          "form_name": properties.formName,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "ubmAH73Pvjx", "01337c1c25b4f3348ab882b1ca7d12a3c49560f93c27e583b08b01021c911dd1");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("lead_generate", {
      "schema": "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
      "form_id": properties.formId1,
      "form_name": properties.formName,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * file_download: when a user clicks a link leading to a file
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.fileExtension - The extension of a file download (for example, 'pdf' or 'txt').
   * @param {string} properties.fileName - The page path of a file download (for example, '/menus/dinner-menu.pdf').
   * @param {string} [properties.clickId1] - The HTML id attribute for an outbound link or file download
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} properties.clickClasses - no description
   * @param {string} properties.clickDestination - Provide URL if the button navigates
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/96x5Eusp665}
   */
  function fileDownload(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFileExtension(properties.fileExtension));
      messages = messages.concat(assertFileName(properties.fileName));
      messages = messages.concat(assertOptionalClickId1(properties.clickId1));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertClickClasses(properties.clickClasses));
      messages = messages.concat(assertClickDestination(properties.clickDestination));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("file_download", Object.keys(properties), [
        "fileExtension",
        "fileName",
        "clickId1",
        "clickText",
        "clickClasses",
        "clickDestination"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "96x5Eusp665", "6f12ccb8994b400284fb9d8b9d1edfd31144c9067ddd9b0f1e8e7ae5499cddc2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("file_download", {
        "schema": "iglu:nl.ns/file_download/jsonschema/1-0-0",
        "file_extension": properties.fileExtension,
        "file_name": properties.fileName,
        "click_id": properties.clickId1,
        "click_text": properties.clickText,
        "click_classes": properties.clickClasses,
        "click_destination": properties.clickDestination,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("96x5Eusp665", "file_download", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/file_download/jsonschema/1-0-0"},
        {id: "HolZTTkkioUB", name: "click_id", value: properties.clickId1},
        {id: "K5J4L8efdGgl", name: "click_classes", value: properties.clickClasses},
        {id: "PqLRY8g1AK7Q", name: "file_name", value: properties.fileName},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "TizyQU9Eo2GE", name: "file_extension", value: properties.fileExtension},
        {id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'file_download': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("file_download", {
          "schema": "iglu:nl.ns/file_download/jsonschema/1-0-0",
          "file_extension": properties.fileExtension,
          "file_name": properties.fileName,
          "click_id": properties.clickId1,
          "click_text": properties.clickText,
          "click_classes": properties.clickClasses,
          "click_destination": properties.clickDestination,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "96x5Eusp665", "6f12ccb8994b400284fb9d8b9d1edfd31144c9067ddd9b0f1e8e7ae5499cddc2");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("file_download", {
      "schema": "iglu:nl.ns/file_download/jsonschema/1-0-0",
      "file_extension": properties.fileExtension,
      "file_name": properties.fileName,
      "click_id": properties.clickId1,
      "click_text": properties.clickText,
      "click_classes": properties.clickClasses,
      "click_destination": properties.clickDestination,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisvergelijker_start: First click during a session on the reisvergelijker
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/d5RrIQuwY3f}
   */
  function reisvergelijkerStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisvergelijker_start", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d5RrIQuwY3f", "4bf4499f75968b01f807ebd164acc32f5e186957c0a90c2c4f83a138e1a2f195", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisvergelijker_start", {
        "schema": "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d5RrIQuwY3f", "reisvergelijker_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0"},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisvergelijker_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisvergelijker_start", {
          "schema": "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "d5RrIQuwY3f", "4bf4499f75968b01f807ebd164acc32f5e186957c0a90c2c4f83a138e1a2f195");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisvergelijker_start", {
      "schema": "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisvergelijker_success: Advise shown to the customer
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/tVvvyMSeNgy}
   */
  function reisvergelijkerSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisvergelijker_success", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tVvvyMSeNgy", "d97ae6b5965021c2786e03e0a775b0df1caf5a59e254a92d19646b9d8dfdfff1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisvergelijker_success", {
        "schema": "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tVvvyMSeNgy", "reisvergelijker_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0"},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisvergelijker_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisvergelijker_success", {
          "schema": "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "tVvvyMSeNgy", "d97ae6b5965021c2786e03e0a775b0df1caf5a59e254a92d19646b9d8dfdfff1");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisvergelijker_success", {
      "schema": "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisplanner_success: A new advice is calculated and displayed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.originType - Type of the origin location like station or address
   * @param {string} [properties.originModalities] - which modalities are checked by user
   * @param {string} properties.destinationType - Type of the destination location like station or address
   * @param {string} properties.arrivalOrDepartureDate - arrival or departure date chosen?
   * @param {string} properties.planDate - What is the date of the journey
   * @param {string} properties.planTime - What is the time of the journey
   * @param {int} properties.minutesToPlanTime - no description
   * @param {string} [properties.optionViaStation] - no description
   * @param {string} [properties.optionTransportOptions] - Included options (trein, bus, metro, tram, veerboot)
   * @param {bool} properties.optionNoReservation - no description
   * @param {bool} properties.optionHasTravelassistance - The user that plans a journey has (or doesn't have) travel assistance enabled
   * @param {bool} properties.optionOnlyLocalTrains - The option to only show local trains (Sprinters)
   * @param {int} [properties.optionExtraTransferTime] - How much extra transfer time is selected
   * @param {float} properties.ticketPrice - price of the ticket
   * @param {string} [properties.origin] - from station of planned trip
   * @param {string} properties.destination - to station
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/6JB9Vvg02a1}
   */
  function reisplannerSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOriginType(properties.originType));
      messages = messages.concat(assertOptionalOriginModalities(properties.originModalities));
      messages = messages.concat(assertDestinationType(properties.destinationType));
      messages = messages.concat(assertArrivalOrDepartureDate(properties.arrivalOrDepartureDate));
      messages = messages.concat(assertPlanDate(properties.planDate));
      messages = messages.concat(assertPlanTime(properties.planTime));
      messages = messages.concat(assertMinutesToPlanTime(properties.minutesToPlanTime));
      messages = messages.concat(assertOptionalOptionViaStation(properties.optionViaStation));
      messages = messages.concat(assertOptionalOptionTransportOptions(properties.optionTransportOptions));
      messages = messages.concat(assertOptionNoReservation(properties.optionNoReservation));
      messages = messages.concat(assertOptionHasTravelassistance(properties.optionHasTravelassistance));
      messages = messages.concat(assertOptionOnlyLocalTrains(properties.optionOnlyLocalTrains));
      messages = messages.concat(assertOptionalOptionExtraTransferTime(properties.optionExtraTransferTime));
      messages = messages.concat(assertTicketPrice(properties.ticketPrice));
      messages = messages.concat(assertOptionalOrigin(properties.origin));
      messages = messages.concat(assertDestination(properties.destination));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisplanner_success", Object.keys(properties), [
        "originType",
        "originModalities",
        "destinationType",
        "arrivalOrDepartureDate",
        "planDate",
        "planTime",
        "minutesToPlanTime",
        "optionViaStation",
        "optionTransportOptions",
        "optionNoReservation",
        "optionHasTravelassistance",
        "optionOnlyLocalTrains",
        "optionExtraTransferTime",
        "ticketPrice",
        "origin",
        "destination"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6JB9Vvg02a1", "813f51942a7647fddd9967a18a4d5ea9b5d971069073339ab4da260ec79fc527", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisplanner_success", {
        "schema": "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
        "origin_type": properties.originType,
        "origin_modalities": properties.originModalities,
        "destination_type": properties.destinationType,
        "arrival_or_departure_date": properties.arrivalOrDepartureDate,
        "plan_date": properties.planDate,
        "plan_time": properties.planTime,
        "minutes_to_plan_time": properties.minutesToPlanTime,
        "option_via_station": properties.optionViaStation,
        "option_transport_options": properties.optionTransportOptions,
        "option_no_reservation": properties.optionNoReservation,
        "option_has_travelassistance": properties.optionHasTravelassistance,
        "option_only_local_trains": properties.optionOnlyLocalTrains,
        "option_extra_transfer_time": properties.optionExtraTransferTime,
        "ticket_price": properties.ticketPrice,
        "origin": properties.origin,
        "destination": properties.destination,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6JB9Vvg02a1", "reisplanner_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0"},
        {id: "8jofQf9ETeBe", name: "option_only_local_trains", value: properties.optionOnlyLocalTrains},
        {id: "CaMQ0XJCJbKL", name: "option_transport_options", value: properties.optionTransportOptions},
        {id: "EhTR7EnR_4-n", name: "option_extra_transfer_time", value: properties.optionExtraTransferTime},
        {id: "JhQcIHY4C9pI", name: "origin_type", value: properties.originType},
        {id: "K5UKR3Wbe9xC", name: "destination", value: properties.destination},
        {id: "MgmcZ65PSEiQ", name: "origin_modalities", value: properties.originModalities},
        {id: "QrQ2jdtpI42P", name: "plan_date", value: properties.planDate},
        {id: "WDi4lr0fPar_", name: "option_no_reservation", value: properties.optionNoReservation},
        {id: "aI7_g6oQRfSk", name: "minutes_to_plan_time", value: properties.minutesToPlanTime},
        {id: "fei9WfaoV0KU", name: "arrival_or_departure_date", value: properties.arrivalOrDepartureDate},
        {id: "hi8osDXdCJVA", name: "plan_time", value: properties.planTime},
        {id: "lztkT6sWa2HW", name: "ticket_price", value: properties.ticketPrice},
        {id: "nXtf5xu83rju", name: "option_via_station", value: properties.optionViaStation},
        {id: "oyE5fJGQ8YEf", name: "origin", value: properties.origin},
        {id: "pzgV0n5Ze47t", name: "destination_type", value: properties.destinationType},
        {id: "xp4K_4mDFr_k", name: "option_has_travelassistance", value: properties.optionHasTravelassistance},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisplanner_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisplanner_success", {
          "schema": "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
          "origin_type": properties.originType,
          "origin_modalities": properties.originModalities,
          "destination_type": properties.destinationType,
          "arrival_or_departure_date": properties.arrivalOrDepartureDate,
          "plan_date": properties.planDate,
          "plan_time": properties.planTime,
          "minutes_to_plan_time": properties.minutesToPlanTime,
          "option_via_station": properties.optionViaStation,
          "option_transport_options": properties.optionTransportOptions,
          "option_no_reservation": properties.optionNoReservation,
          "option_has_travelassistance": properties.optionHasTravelassistance,
          "option_only_local_trains": properties.optionOnlyLocalTrains,
          "option_extra_transfer_time": properties.optionExtraTransferTime,
          "ticket_price": properties.ticketPrice,
          "origin": properties.origin,
          "destination": properties.destination,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "6JB9Vvg02a1", "813f51942a7647fddd9967a18a4d5ea9b5d971069073339ab4da260ec79fc527");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisplanner_success", {
      "schema": "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
      "origin_type": properties.originType,
      "origin_modalities": properties.originModalities,
      "destination_type": properties.destinationType,
      "arrival_or_departure_date": properties.arrivalOrDepartureDate,
      "plan_date": properties.planDate,
      "plan_time": properties.planTime,
      "minutes_to_plan_time": properties.minutesToPlanTime,
      "option_via_station": properties.optionViaStation,
      "option_transport_options": properties.optionTransportOptions,
      "option_no_reservation": properties.optionNoReservation,
      "option_has_travelassistance": properties.optionHasTravelassistance,
      "option_only_local_trains": properties.optionOnlyLocalTrains,
      "option_extra_transfer_time": properties.optionExtraTransferTime,
      "ticket_price": properties.ticketPrice,
      "origin": properties.origin,
      "destination": properties.destination,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisplanner_error: Pop-up shown when journey cannot be planned
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.errorMessage - What error message(s) does the user see? List of translation keys or strings.
   * @param {string} properties.errorStatus - no description
   * @param {string} properties.errorCategory - no description
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/le4Df-rdG3z}
   */
  function reisplannerError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertErrorStatus(properties.errorStatus));
      messages = messages.concat(assertErrorCategory(properties.errorCategory));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisplanner_error", Object.keys(properties), [
        "errorMessage",
        "errorStatus",
        "errorCategory"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "le4Df-rdG3z", "882821ee54d41e7f209a6b8a10695ec2eb87909bec8dcb7af8c447d02fc70e91", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisplanner_error", {
        "schema": "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0",
        "error_message": properties.errorMessage,
        "error_status": properties.errorStatus,
        "error_category": properties.errorCategory,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("le4Df-rdG3z", "reisplanner_error", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0"},
        {id: "7Nf2EeEBl", name: "error_category", value: properties.errorCategory},
        {id: "_UC5Zg5bYPN", name: "error_message", value: properties.errorMessage},
        {id: "shuP1-uKm", name: "error_status", value: properties.errorStatus},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisplanner_error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisplanner_error", {
          "schema": "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0",
          "error_message": properties.errorMessage,
          "error_status": properties.errorStatus,
          "error_category": properties.errorCategory,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "le4Df-rdG3z", "882821ee54d41e7f209a6b8a10695ec2eb87909bec8dcb7af8c447d02fc70e91");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisplanner_error", {
      "schema": "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0",
      "error_message": properties.errorMessage,
      "error_status": properties.errorStatus,
      "error_category": properties.errorCategory,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * cookie_consent_submit: Status after closing the cookiebar
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.cookieConsentStatus] - Value of the cookieConsentStatus cookie
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/KPs9gjyZhq1}
   */
  function cookieConsentSubmit(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalCookieConsentStatus(properties.cookieConsentStatus));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("cookie_consent_submit", Object.keys(properties), [
        "cookieConsentStatus"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KPs9gjyZhq1", "d244c03c7aa2f38a1b65be5a3178ad7eb533547992a387f03f4dcd148536111b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("cookie_consent_submit", {
        "schema": "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
        "cookie_consent_status": properties.cookieConsentStatus,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KPs9gjyZhq1", "cookie_consent_submit", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2"},
        {id: "-DxiaheG2mil", name: "cookie_consent_status", value: properties.cookieConsentStatus},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'cookie_consent_submit': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cookie_consent_submit", {
          "schema": "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
          "cookie_consent_status": properties.cookieConsentStatus,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "KPs9gjyZhq1", "d244c03c7aa2f38a1b65be5a3178ad7eb533547992a387f03f4dcd148536111b");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("cookie_consent_submit", {
      "schema": "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
      "cookie_consent_status": properties.cookieConsentStatus,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * push_consent: When toggle is changed for push consent
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.pushConsentStatus - Array with modified permissions and status
[
  {
    'type':'En? Hoe is je reis?',
    'status':'true',
  }
]
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/wubhhpkiKqv}
   */
  function pushConsent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPushConsentStatus(properties.pushConsentStatus));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("push_consent", Object.keys(properties), [
        "pushConsentStatus"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wubhhpkiKqv", "cbcd35c09d65a8695dbda1ed7e3c451ed11b4e4b872b3b5c7654b04e7aaecc36", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("push_consent", {
        "schema": "iglu:nl.ns/push_consent/jsonschema/1-0-0",
        "push_consent_status": properties.pushConsentStatus,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wubhhpkiKqv", "push_consent", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/push_consent/jsonschema/1-0-0"},
        {id: "mE3yslcjncEm", name: "push_consent_status", value: properties.pushConsentStatus},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'push_consent': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("push_consent", {
          "schema": "iglu:nl.ns/push_consent/jsonschema/1-0-0",
          "push_consent_status": properties.pushConsentStatus,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "wubhhpkiKqv", "cbcd35c09d65a8695dbda1ed7e3c451ed11b4e4b872b3b5c7654b04e7aaecc36");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("push_consent", {
      "schema": "iglu:nl.ns/push_consent/jsonschema/1-0-0",
      "push_consent_status": properties.pushConsentStatus,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisregisseur_change_permission: Triggers when permission is toggled
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.permissions - Array with modified permissions and status
[
  {
    'type':'Commercieel',
    'status':'true',
  },
  {
    'type':'Reisgegevens delen',
    'status':'false',
  },
]
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/TjGfck4PwVP}
   */
  function reisregisseurChangePermission(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPermissions(properties.permissions));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisregisseur_change_permission", Object.keys(properties), [
        "permissions"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TjGfck4PwVP", "33bcb40f49a3ce3a6b496a25a4f7453e6e15203fece45e7e2f5c77e119a5fa22", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisregisseur_change_permission", {
        "schema": "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
        "permissions": properties.permissions,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TjGfck4PwVP", "reisregisseur_change_permission", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0"},
        {id: "b6ebejYlEx2Y", name: "permissions", value: properties.permissions},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisregisseur_change_permission': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisregisseur_change_permission", {
          "schema": "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
          "permissions": properties.permissions,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "TjGfck4PwVP", "33bcb40f49a3ce3a6b496a25a4f7453e6e15203fece45e7e2f5c77e119a5fa22");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisregisseur_change_permission", {
      "schema": "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
      "permissions": properties.permissions,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * nba_view: incl. UTMS from email
when users triggers an NBA
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.ucId - id of the NBA fe uc0150. Stated in the CDP.
   * @param {string} properties.ucVariant - variant of the uc. fe you always have a 'control', but also a variant 'versieA', 'versieB' etc. depending on the number of variants the marketeer made. A customer can only see one variant.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/QJN-6_MntPF}
   */
  function nbaView(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUcId(properties.ucId));
      messages = messages.concat(assertUcVariant(properties.ucVariant));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("nba_view", Object.keys(properties), [
        "ucId",
        "ucVariant"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QJN-6_MntPF", "33c0f9ff6567af09825449de11622f88d29e808df3daf9b4922522eeca1785e0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("nba_view", {
        "schema": "iglu:nl.ns/nba_view/jsonschema/1-0-3",
        "uc_id": properties.ucId,
        "uc_variant": properties.ucVariant,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QJN-6_MntPF", "nba_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/nba_view/jsonschema/1-0-3"},
        {id: "7OXAcO_7A", name: "uc_variant", value: properties.ucVariant},
        {id: "gbSQirnPl", name: "uc_id", value: properties.ucId},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'nba_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_view", {
          "schema": "iglu:nl.ns/nba_view/jsonschema/1-0-3",
          "uc_id": properties.ucId,
          "uc_variant": properties.ucVariant,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "QJN-6_MntPF", "33c0f9ff6567af09825449de11622f88d29e808df3daf9b4922522eeca1785e0");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("nba_view", {
      "schema": "iglu:nl.ns/nba_view/jsonschema/1-0-3",
      "uc_id": properties.ucId,
      "uc_variant": properties.ucVariant,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * nba_success: target for NBA is matched
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.ucId - id of the NBA fe uc0150. Stated in the CDP.
   * @param {string} properties.ucVariant - variant of the uc. fe you always have a 'control', but also a variant 'versieA', 'versieB' etc. depending on the number of variants the marketeer made. A customer can only see one variant.
   * @param {string} properties.ucLocation - location the uc is shown. fe. web: ns.nl/spoordeelwinkel of app: travelplanner
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/OcvSS16e-Le}
   */
  function nbaSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUcId(properties.ucId));
      messages = messages.concat(assertUcVariant(properties.ucVariant));
      messages = messages.concat(assertUcLocation(properties.ucLocation));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("nba_success", Object.keys(properties), [
        "ucId",
        "ucVariant",
        "ucLocation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OcvSS16e-Le", "9ac3ebc6a2e4a2ddaa4695e3fcf55be181055857b93938ec47a5434a4dfef4b8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("nba_success", {
        "schema": "iglu:nl.ns/nba_success/jsonschema/1-0-0",
        "uc_id": properties.ucId,
        "uc_variant": properties.ucVariant,
        "uc_location": properties.ucLocation,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OcvSS16e-Le", "nba_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/nba_success/jsonschema/1-0-0"},
        {id: "7OXAcO_7A", name: "uc_variant", value: properties.ucVariant},
        {id: "Am6PkQ_Uo", name: "uc_location", value: properties.ucLocation},
        {id: "gbSQirnPl", name: "uc_id", value: properties.ucId},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'nba_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_success", {
          "schema": "iglu:nl.ns/nba_success/jsonschema/1-0-0",
          "uc_id": properties.ucId,
          "uc_variant": properties.ucVariant,
          "uc_location": properties.ucLocation,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "OcvSS16e-Le", "9ac3ebc6a2e4a2ddaa4695e3fcf55be181055857b93938ec47a5434a4dfef4b8");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("nba_success", {
      "schema": "iglu:nl.ns/nba_success/jsonschema/1-0-0",
      "uc_id": properties.ucId,
      "uc_variant": properties.ucVariant,
      "uc_location": properties.ucLocation,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * nba_audience_add: Add audience of an NBA
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.testTool - Source of the experiment (optimizely, relay42, blueconic)
   * @param {string} properties.testLocation - e.g. homepage_banner, sdw, email, Facebook
   * @param {string} properties.testId - for NBAs, ucxxxx
for Experiments, specific experiment ID
   * @param {string} properties.testVariant - Test group
Control Group: ctrl
Variant: number_description i.e. v01_change_buttons_bottom
   * @param {string} [properties.testAudienceId] - Tool-specific ID of the test group
   * @param {string} properties.cluster - Cluster owner for test
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/XmNclzkwEt8}
   */
  function nbaAudienceAdd(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTestTool(properties.testTool));
      messages = messages.concat(assertTestLocation(properties.testLocation));
      messages = messages.concat(assertTestId(properties.testId));
      messages = messages.concat(assertTestVariant(properties.testVariant));
      messages = messages.concat(assertOptionalTestAudienceId(properties.testAudienceId));
      messages = messages.concat(assertCluster(properties.cluster));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("nba_audience_add", Object.keys(properties), [
        "testTool",
        "testLocation",
        "testId",
        "testVariant",
        "testAudienceId",
        "cluster"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XmNclzkwEt8", "456d711d22f5cd6b6077d41669addc185ee914b266220bda27197a44a4ffc6d5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("nba_audience_add", {
        "schema": "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
        "test_tool": properties.testTool,
        "test_location": properties.testLocation,
        "test_id": properties.testId,
        "test_variant": properties.testVariant,
        "test_audience_id": properties.testAudienceId,
        "cluster": properties.cluster,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XmNclzkwEt8", "nba_audience_add", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1"},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "aF92rWblhlD9", name: "cluster", value: properties.cluster},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'nba_audience_add': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_audience_add", {
          "schema": "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
          "test_tool": properties.testTool,
          "test_location": properties.testLocation,
          "test_id": properties.testId,
          "test_variant": properties.testVariant,
          "test_audience_id": properties.testAudienceId,
          "cluster": properties.cluster,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "XmNclzkwEt8", "456d711d22f5cd6b6077d41669addc185ee914b266220bda27197a44a4ffc6d5");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("nba_audience_add", {
      "schema": "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
      "test_tool": properties.testTool,
      "test_location": properties.testLocation,
      "test_id": properties.testId,
      "test_variant": properties.testVariant,
      "test_audience_id": properties.testAudienceId,
      "cluster": properties.cluster,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * experiment_view: view a variant or the control version of an experiment
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.testTool - Source of the experiment (optimizely, relay42, blueconic)
   * @param {string} properties.testTeam - Team that initiates the test
   * @param {string} [properties.testLocation] - e.g. homepage_banner, sdw, email, Facebook
   * @param {string} properties.testId - for NBAs, ucxxxx
for Experiments, specific experiment ID
   * @param {string} properties.testVariant - Test group
Control Group: ctrl
Variant: number_description i.e. v01_change_buttons_bottom
   * @param {string} [properties.testAudienceId] - Tool-specific ID of the test group
   * @param {string} [properties.testDescription] - Short Hypotheses or purpose of this test
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/B_v6cdwUvaM}
   */
  function experimentView(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTestTool(properties.testTool));
      messages = messages.concat(assertTestTeam(properties.testTeam));
      messages = messages.concat(assertOptionalTestLocation(properties.testLocation));
      messages = messages.concat(assertTestId(properties.testId));
      messages = messages.concat(assertTestVariant(properties.testVariant));
      messages = messages.concat(assertOptionalTestAudienceId(properties.testAudienceId));
      messages = messages.concat(assertOptionalTestDescription(properties.testDescription));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("experiment_view", Object.keys(properties), [
        "testTool",
        "testTeam",
        "testLocation",
        "testId",
        "testVariant",
        "testAudienceId",
        "testDescription"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "B_v6cdwUvaM", "14965794f94f5bde1975c678123a6bdf1168019b726f9c532706a5ea1d2bbbfe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("experiment_view", {
        "schema": "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
        "test_tool": properties.testTool,
        "test_team": properties.testTeam,
        "test_location": properties.testLocation,
        "test_id": properties.testId,
        "test_variant": properties.testVariant,
        "test_audience_id": properties.testAudienceId,
        "test_description": properties.testDescription,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("B_v6cdwUvaM", "experiment_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/experiment_view/jsonschema/1-0-5"},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "ij0L0WRQXuPq", name: "test_team", value: properties.testTeam},
        {id: "pnPG0qR_-", name: "test_description", value: properties.testDescription},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'experiment_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_view", {
          "schema": "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
          "test_tool": properties.testTool,
          "test_team": properties.testTeam,
          "test_location": properties.testLocation,
          "test_id": properties.testId,
          "test_variant": properties.testVariant,
          "test_audience_id": properties.testAudienceId,
          "test_description": properties.testDescription,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "B_v6cdwUvaM", "14965794f94f5bde1975c678123a6bdf1168019b726f9c532706a5ea1d2bbbfe");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("experiment_view", {
      "schema": "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
      "test_tool": properties.testTool,
      "test_team": properties.testTeam,
      "test_location": properties.testLocation,
      "test_id": properties.testId,
      "test_variant": properties.testVariant,
      "test_audience_id": properties.testAudienceId,
      "test_description": properties.testDescription,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * experiment_success: succes of an experiment
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.testTool - Source of the experiment (optimizely, relay42, blueconic)
   * @param {string} properties.testTeam - Team that initiates the test
   * @param {string} properties.testLocation - e.g. homepage_banner, sdw, email, Facebook
   * @param {string} properties.testId - for NBAs, ucxxxx
for Experiments, specific experiment ID
   * @param {string} properties.testVariant - Test group
Control Group: ctrl
Variant: number_description i.e. v01_change_buttons_bottom
   * @param {string} [properties.testAudienceId] - Tool-specific ID of the test group
   * @param {string} [properties.destinationPath] - In case of a click, show the full page URL of the destination
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/xtxv7EspiUx}
   */
  function experimentSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTestTool(properties.testTool));
      messages = messages.concat(assertTestTeam(properties.testTeam));
      messages = messages.concat(assertTestLocation(properties.testLocation));
      messages = messages.concat(assertTestId(properties.testId));
      messages = messages.concat(assertTestVariant(properties.testVariant));
      messages = messages.concat(assertOptionalTestAudienceId(properties.testAudienceId));
      messages = messages.concat(assertOptionalDestinationPath(properties.destinationPath));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("experiment_success", Object.keys(properties), [
        "testTool",
        "testTeam",
        "testLocation",
        "testId",
        "testVariant",
        "testAudienceId",
        "destinationPath",
        "clickText"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xtxv7EspiUx", "1d917a578105d0520ae249b9f617cf39e5c9bf3a2e588944bd702afd4f2a8a54", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("experiment_success", {
        "schema": "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
        "test_tool": properties.testTool,
        "test_team": properties.testTeam,
        "test_location": properties.testLocation,
        "test_id": properties.testId,
        "test_variant": properties.testVariant,
        "test_audience_id": properties.testAudienceId,
        "destination_path": properties.destinationPath,
        "click_text": properties.clickText,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xtxv7EspiUx", "experiment_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/experiment_success/jsonschema/1-0-0"},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "ij0L0WRQXuPq", name: "test_team", value: properties.testTeam},
        {id: "twaKzqqM-SP3", name: "destination_path", value: properties.destinationPath},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'experiment_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_success", {
          "schema": "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
          "test_tool": properties.testTool,
          "test_team": properties.testTeam,
          "test_location": properties.testLocation,
          "test_id": properties.testId,
          "test_variant": properties.testVariant,
          "test_audience_id": properties.testAudienceId,
          "destination_path": properties.destinationPath,
          "click_text": properties.clickText,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "xtxv7EspiUx", "1d917a578105d0520ae249b9f617cf39e5c9bf3a2e588944bd702afd4f2a8a54");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("experiment_success", {
      "schema": "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
      "test_tool": properties.testTool,
      "test_team": properties.testTeam,
      "test_location": properties.testLocation,
      "test_id": properties.testId,
      "test_variant": properties.testVariant,
      "test_audience_id": properties.testAudienceId,
      "destination_path": properties.destinationPath,
      "click_text": properties.clickText,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * add_to_cart: When a product is added to the cart
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/XIShibtSw}
   */
  function addToCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("add_to_cart", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XIShibtSw", "66140d1501b414a085694817998cbb7dd40bfe6f58b3b2c3862bb5679dc3aaf4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("add_to_cart", {
        "schema": "iglu:nl.ns/add_to_cart/jsonschema/1-0-6",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XIShibtSw", "add_to_cart", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_to_cart/jsonschema/1-0-6"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'add_to_cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_to_cart", {
          "schema": "iglu:nl.ns/add_to_cart/jsonschema/1-0-6",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "XIShibtSw", "66140d1501b414a085694817998cbb7dd40bfe6f58b3b2c3862bb5679dc3aaf4");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("add_to_cart", {
      "schema": "iglu:nl.ns/add_to_cart/jsonschema/1-0-6",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * remove_from_cart: When a product is removed from the cart
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FnwydILgs}
   */
  function removeFromCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("remove_from_cart", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FnwydILgs", "6dd8e14b975d7515d71514aa937a20256f2cae72b46a19606b9032474e86316f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("remove_from_cart", {
        "schema": "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FnwydILgs", "remove_from_cart", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'remove_from_cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("remove_from_cart", {
          "schema": "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "FnwydILgs", "6dd8e14b975d7515d71514aa937a20256f2cae72b46a19606b9032474e86316f");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("remove_from_cart", {
      "schema": "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * view_item_list: Triggers when the product detail page is viewed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} [properties.itemListId] - id of the list viewed
   * @param {string} [properties.itemListName] - The name of the list in which the item was presented to the user
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/deRK33OE7}
   */
  function viewItemList(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertOptionalItemListId(properties.itemListId));
      messages = messages.concat(assertOptionalItemListName(properties.itemListName));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("view_item_list", Object.keys(properties), [
        "value",
        "items",
        "itemListId",
        "itemListName",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "deRK33OE7", "b2b4fc3b2204aa59a10555c2b4c69d720fb888aa854c4e7b9453462d0d8d1cd7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("view_item_list", {
        "currency": "EUR",
        "schema": "iglu:nl.ns/view_item_list/jsonschema/1-0-2",
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "item_list_id": properties.itemListId,
        "item_list_name": properties.itemListName,
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("deRK33OE7", "view_item_list", messages, [
        {id: "GuYrcDncVS5", name: "currency", value: "EUR"},
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/view_item_list/jsonschema/1-0-2"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "LydSjYynFBlR", name: "item_list_name", value: properties.itemListName},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qAs6FFElba8q", name: "item_list_id", value: properties.itemListId},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'view_item_list': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item_list", {
          "currency": "EUR",
          "schema": "iglu:nl.ns/view_item_list/jsonschema/1-0-2",
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "item_list_id": properties.itemListId,
          "item_list_name": properties.itemListName,
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "deRK33OE7", "b2b4fc3b2204aa59a10555c2b4c69d720fb888aa854c4e7b9453462d0d8d1cd7");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("view_item_list", {
      "currency": "EUR",
      "schema": "iglu:nl.ns/view_item_list/jsonschema/1-0-2",
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "item_list_id": properties.itemListId,
      "item_list_name": properties.itemListName,
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * purchase_unconfirmed: Event on the last interaction before navigating to the payment provider
   * 
   * When to trigger this event:
   * 1. Bij klikken op betaal button
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/sudJ_WFJW/trigger/moDfbyEZ4
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {string} properties.transactionId - Transaction or Order ID of the order
   * @param {Array<string>} [properties.paymentType] - payment type like iDeal, Creditcard etc
   * @param {string} [properties.bankSelected] - no description
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * @param {Array<object>} [properties.existingProduct] - current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
   * @param {string} [properties.coupon] - coupon-code or campaign id
   * @param {float} [properties.discount] - Item discount value
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/sudJ_WFJW}
   */
  function purchaseUnconfirmed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertTransactionId(properties.transactionId));
      messages = messages.concat(assertOptionalPaymentType(properties.paymentType));
      messages = messages.concat(assertOptionalBankSelected(properties.bankSelected));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertOptionalExistingProduct(properties.existingProduct));
      messages = messages.concat(assertOptionalCoupon(properties.coupon));
      messages = messages.concat(assertOptionalDiscount(properties.discount));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("purchase_unconfirmed", Object.keys(properties), [
        "value",
        "items",
        "nsShop",
        "transactionId",
        "paymentType",
        "bankSelected",
        "salesChannel",
        "existingProduct",
        "coupon",
        "discount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sudJ_WFJW", "8f1a82d4365bc96ffffff0c059c4bd93f7c5b4c383dacd58e00009344bea982a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("purchase_unconfirmed", {
        "currency": "EUR",
        "schema": "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4",
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "transaction_id": properties.transactionId,
        "payment_type": properties.paymentType,
        "bank_selected": properties.bankSelected,
        "sales_channel": properties.salesChannel,
        "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
          properties.existingProduct.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "quantity": value.quantity,
            "item_category": value.itemCategory,
            "item_category2": value.itemCategory2,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
          };
          }) : properties.existingProduct,
        "coupon": properties.coupon,
        "discount": properties.discount,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sudJ_WFJW", "purchase_unconfirmed", messages, [
        {id: "GuYrcDncVS5", name: "currency", value: "EUR"},
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4"},
        {id: "06ak1UmwgYlK", name: "payment_type", value: properties.paymentType},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "SCki6fM2wea", name: "transaction_id", value: properties.transactionId},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_8eP6aJ0U", name: "bank_selected", value: properties.bankSelected},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'purchase_unconfirmed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("purchase_unconfirmed", {
          "currency": "EUR",
          "schema": "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4",
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "transaction_id": properties.transactionId,
          "payment_type": properties.paymentType,
          "bank_selected": properties.bankSelected,
          "sales_channel": properties.salesChannel,
          "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
            properties.existingProduct.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "quantity": value.quantity,
              "item_category": value.itemCategory,
              "item_category2": value.itemCategory2,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
            };
            }) : properties.existingProduct,
          "coupon": properties.coupon,
          "discount": properties.discount,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "sudJ_WFJW", "8f1a82d4365bc96ffffff0c059c4bd93f7c5b4c383dacd58e00009344bea982a");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("purchase_unconfirmed", {
      "currency": "EUR",
      "schema": "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4",
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "transaction_id": properties.transactionId,
      "payment_type": properties.paymentType,
      "bank_selected": properties.bankSelected,
      "sales_channel": properties.salesChannel,
      "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
        properties.existingProduct.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "quantity": value.quantity,
          "item_category": value.itemCategory,
          "item_category2": value.itemCategory2,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
        };
        }) : properties.existingProduct,
      "coupon": properties.coupon,
      "discount": properties.discount,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * add_shipping_info: The step before the last step (add_payment_info)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mkKucON6P}
   */
  function addShippingInfo(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("add_shipping_info", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mkKucON6P", "6dda8c05c2168ef6a482d714eb8e2e311d9067647713c77b11b3f1c1c9d098a2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("add_shipping_info", {
        "schema": "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mkKucON6P", "add_shipping_info", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'add_shipping_info': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_shipping_info", {
          "schema": "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "mkKucON6P", "6dda8c05c2168ef6a482d714eb8e2e311d9067647713c77b11b3f1c1c9d098a2");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("add_shipping_info", {
      "schema": "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * add_payment_info: Final step of the purchase flow
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster fe lok, ns_flex, ns_businesscard, spoordeelwinke
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/X4CYs12Op}
   */
  function addPaymentInfo(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("add_payment_info", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "X4CYs12Op", "3d71c6ed102afc20045398a9e605caa20ef1fd2e5ed22b084b20a9b9d45ba5a1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("add_payment_info", {
        "schema": "iglu:nl.ns/add_payment_info/jsonschema/1-0-2",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "ticket_class": value.ticketClass,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("X4CYs12Op", "add_payment_info", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_payment_info/jsonschema/1-0-2"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'add_payment_info': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_payment_info", {
          "schema": "iglu:nl.ns/add_payment_info/jsonschema/1-0-2",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "ticket_class": value.ticketClass,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "X4CYs12Op", "3d71c6ed102afc20045398a9e605caa20ef1fd2e5ed22b084b20a9b9d45ba5a1");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("add_payment_info", {
      "schema": "iglu:nl.ns/add_payment_info/jsonschema/1-0-2",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "ticket_class": value.ticketClass,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * logout_success: Event sent when a user logs out of the MijnNS application
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/6KPbzWfr6}
   */
  function logoutSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("logout_success", Object.keys(properties), [
        "mijnnsVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6KPbzWfr6", "ed16e2184ca97d8e8471aca657d57cb53a83c9f3a805a45fa67b37dfced34c49", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("logout_success", {
        "schema": "iglu:nl.ns/logout_success/jsonschema/1-0-1",
        "mijnns_version": properties.mijnnsVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6KPbzWfr6", "logout_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/logout_success/jsonschema/1-0-1"},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'logout_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("logout_success", {
          "schema": "iglu:nl.ns/logout_success/jsonschema/1-0-1",
          "mijnns_version": properties.mijnnsVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "6KPbzWfr6", "ed16e2184ca97d8e8471aca657d57cb53a83c9f3a805a45fa67b37dfced34c49");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("logout_success", {
      "schema": "iglu:nl.ns/logout_success/jsonschema/1-0-1",
      "mijnns_version": properties.mijnnsVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
      NsDataQueue.unidentify();
    } else {
      // do nothing
    }
  }
  
  exports.Platform = Platform;
  exports.PaymentType = PaymentType;
  exports.Schema = Schema;
  exports.ChatInitiator = ChatInitiator;
  exports.Language = Language;
  exports.NsShop = NsShop;
  exports.FeedbackPlatform = FeedbackPlatform;
  exports.Currency = Currency;
  exports.OriginType = OriginType;
  exports.ItemListName = ItemListName;
  exports.CustomerEntity = CustomerEntity;
  exports.Cluster = Cluster;
  exports.ChatClickSource = ChatClickSource;
  exports.WebsiteVersion = WebsiteVersion;
  exports.MijnnsVersion = MijnnsVersion;
  exports.DestinationType = DestinationType;
  exports.ItemListId = ItemListId;
  exports.NsEnvironment = NsEnvironment;
  exports.Method = Method;
  exports.setAvoLogger = setAvoLogger;
  exports.registrationStart = registrationStart;
  exports.registrationSuccess = registrationSuccess;
  exports.loginStart = loginStart;
  exports.loginError = loginError;
  exports.sessionStart = sessionStart;
  exports.scroll = scroll;
  exports.visitQualified = visitQualified;
  exports.beginCheckout = beginCheckout;
  exports.purchase = purchase;
  exports.click = click;
  exports.feedbackGive = feedbackGive;
  exports.contentShare = contentShare;
  exports.formStart = formStart;
  exports.formSubmit = formSubmit;
  exports.formError = formError;
  exports.viewItem = viewItem;
  exports.keuzehulpClick = keuzehulpClick;
  exports.keuzehulpSuccess = keuzehulpSuccess;
  exports.chatStart = chatStart;
  exports.videoStart = videoStart;
  exports.videoProgress = videoProgress;
  exports.videoComplete = videoComplete;
  exports.leadGenerate = leadGenerate;
  exports.fileDownload = fileDownload;
  exports.reisvergelijkerStart = reisvergelijkerStart;
  exports.reisvergelijkerSuccess = reisvergelijkerSuccess;
  exports.reisplannerSuccess = reisplannerSuccess;
  exports.reisplannerError = reisplannerError;
  exports.cookieConsentSubmit = cookieConsentSubmit;
  exports.pushConsent = pushConsent;
  exports.reisregisseurChangePermission = reisregisseurChangePermission;
  exports.nbaView = nbaView;
  exports.nbaSuccess = nbaSuccess;
  exports.nbaAudienceAdd = nbaAudienceAdd;
  exports.experimentView = experimentView;
  exports.experimentSuccess = experimentSuccess;
  exports.addToCart = addToCart;
  exports.removeFromCart = removeFromCart;
  exports.viewItemList = viewItemList;
  exports.purchaseUnconfirmed = purchaseUnconfirmed;
  exports.addShippingInfo = addShippingInfo;
  exports.addPaymentInfo = addPaymentInfo;
  exports.logoutSuccess = logoutSuccess;
  exports.setSystemProperties_ = setSystemProperties_;
  exports.setSystemProperties = setSystemProperties;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
}(typeof exports === 'undefined' ? this.SourceJsGenericUtilsAvo = {} : exports));

// AVOMODULEMAP:"SourceJsGenericUtilsAvo"
// AVOEVENTMAP:["registrationStart","registrationSuccess","loginStart","loginError","sessionStart","scroll","visitQualified","beginCheckout","purchase","click","feedbackGive","contentShare","formStart","formSubmit","formError","viewItem","keuzehulpClick","keuzehulpSuccess","chatStart","videoStart","videoProgress","videoComplete","leadGenerate","fileDownload","reisvergelijkerStart","reisvergelijkerSuccess","reisplannerSuccess","reisplannerError","cookieConsentSubmit","pushConsent","reisregisseurChangePermission","nbaView","nbaSuccess","nbaAudienceAdd","experimentView","experimentSuccess","addToCart","removeFromCart","viewItemList","purchaseUnconfirmed","addShippingInfo","addPaymentInfo","logoutSuccess"]
